export default {
    "Player":"主角",
    "n00001":"火工头陀果福",
    "n00003":"僧侣果清",
    "n00007":"僧侣果全",
    "n00008":"金鼎禅师",
    "n00013":"大黑天神使者",
    "n00013b":"大黑天神使者",
    "n00015a":"南诏乱军",
    "n00016":"南诏乱军头目",
    "n00017":"谭伯",
    "n00020":"私盐贩子",
    "n51001":"段思平",
    "n00029":"绣眉",
    "n00029b":"绣眉",
    "n00035a":"灰狼",
    "n00035b":"灰狼",
    "n00035c":"大灰狼",
    "n00035d":"灰狼",
    "n00035e":"灰狼",
    "n00035f":"大灰狼",
    "n00035g":"灰狼",
    "n00035h":"灰狼",
    "n00035i":"大灰狼",
    "n00038a":"泼猴",
    "n00038b":"泼猴",
    "n00038c":"大泼猴",
    "n00038d":"泼猴",
    "n00038e":"泼猴",
    "n00038f":"大泼猴",
    "n00038g":"泼猴",
    "n00038h":"泼猴",
    "n00038i":"大泼猴",
    "n00045a":"水贼",
    "n00045b":"水贼",
    "n00045c":"水贼",
    "n00045d":"水贼",
    "n00045e":"水贼",
    "n00045f":"水贼",
    "n00045g":"水贼",
    "n00045h":"水贼",
    "n00045i":"水贼",
    "n00045j":"水贼",
    "n00046":"水贼头目",
    "n00047a":"缇骑",
    "n00047b":"缇骑",
    "n00047c":"缇骑",
    "n00047d":"缇骑",
    "n00047e":"缇骑",
    "n00047f":"缇骑",
    "n00047g":"缇骑",
    "n00047h":"缇骑",
    "n00048":"指挥佥事陈坤",
    "n00070a":"流寇小头目",
    "n00070b":"流寇",
    "n00070c":"流寇",
    "n00070d":"流寇",
    "n00070e":"流寇",
    "n00070f":"流寇",
    "n00070g":"流寇",
    "n00070h":"流寇",
    "n00070i":"流寇",
    "n00070j":"流寇",
    "n00073a":"流寇",
    "n00073b":"流寇",
    "n00075a":"不赦楼杀手",
    "n00075b":"不赦楼杀手",
    "n00075c":"不赦楼杀手",
    "n00075d":"不赦楼杀手",
    "n00075e":"不赦楼杀手",
    "n00075f":"不赦楼杀手",
    "n00077a":"不赦楼狱卒",
    "n00077b":"不赦楼狱卒",
    "n00077c":"不赦楼狱卒",
    "n00077d":"不赦楼狱卒",
    "n00077e":"不赦楼狱卒",
    "n00077f":"不赦楼狱卒",
    "n00078a":"官兵",
    "n00078e":"官兵",
    "n00078k":"官兵",
    "n00078p":"官兵",
    "n00078t":"官兵",
    "n00078b":"官兵",
    "n00078c":"官兵",
    "n00078d":"官兵",
    "n00078f":"官兵",
    "n00078g":"官兵",
    "n00078h":"官兵",
    "n00078i":"官兵",
    "n00078j":"官兵",
    "n00078l":"官兵",
    "n00078m":"官兵",
    "n00078n":"官兵",
    "n00078o":"官兵",
    "n00078q":"官兵",
    "n00078r":"官兵",
    "n00078s":"官兵",
    "n00082":"解凛仁",
    "n00083":"凌霜峻",
    "n00086":"查婆婆",
    "n00087":"余老伯",
    "n00090":"田老伯",
    "n00092a":"妖人",
    "n00092b":"妖人",
    "n00092c":"妖人",
    "n00095a":"丹尸",
    "n00095b":"丹尸",
    "n00095c":"丹尸",
    "n00095d":"丹尸",
    "n00095e":"丹尸",
    "n00095f":"丹尸",
    "n00096a":"赤丹宫门人",
    "n00096b":"赤丹宫门人",
    "n00096c":"赤丹宫门人",
    "n00096d":"赤丹宫门人",
    "n00096e":"赤丹宫门人",
    "n00096f":"赤丹宫门人",
    "n00097a":"青城弟子",
    "n00097b":"青城弟子",
    "n00098a":"赤丹宫仆妇",
    "n00098b":"赤丹宫长工",
    "n00098c":"赤丹宫道僮",
    "n00099":"赤丹掌令使",
    "n00100a":"扶摇四仙",
    "n00100b":"扶摇四仙",
    "n00100c":"扶摇四仙",
    "n00100d":"扶摇四仙",
    "n00101":"赤丹掌炉使",
    "n00102":"赤丹宫宫主 谢荆生",
    "n00103a":"都司弓箭手",
    "n00103b":"都司弓箭手",
    "n00103c":"都司弓箭手",
    "n00103d":"都司弓箭手",
    "n00105a":"西川都司精兵",
    "n00105b":"西川都司精兵",
    "n00105c":"西川都司精兵",
    "n00109a":"南诏禁军",
    "n00109b":"南诏禁军",
    "n00109c":"南诏禁军",
    "n00110a":"白衣派武僧",
    "n00110b":"白衣派武僧",
    "n00110c":"白衣派武僧",
    "n00111a":"豹王寨巨寇",
    "n00111b":"豹王寨巨寇",
    "n00111c":"豹王寨巨寇",
    "n00112a":"擎天寨奸",
    "n00112b":"擎天寨奸",
    "n00112c":"擎天寨奸",
    "n00113a":"明教掌旗使",
    "n00113b":"明教掌旗使",
    "n00113c":"明教掌旗使",
    "n00113d":"明教掌旗使",
    "n00114a":"山魈厉鬼",
    "n00114b":"山魈厉鬼",
    "n00114c":"山魈厉鬼",
    "n00115a":"段家军精兵",
    "n00115b":"段家军精兵",
    "n00116a":"老练鹰猎人",
    "n00116b":"老练鹰猎人",
    "n00117a":"擎天寨义勇",
    "n00117b":"擎天寨义勇",
    "n00118a":"马帮头目",
    "n00118b":"马帮头目",
    "n90004":"铁匠 铁彻天",
    "n00119b":"卖药郎中",
    "n00122":"棋具商人",
    "n06001":"茶铺伙计",
    "n06003":"客栈老板",
    "n06005":"茶馆老板",
    "n07001":"皇甫登云",
    "n07001a":"皇甫登云",
    "n07001b":"皇甫登云",
    "n07002":"百里惮赫",
    "n07003":"冯观戏",
    "n07004":"李惑相",
    "n90215":"蓝拂衣",
    "n07006":"云种火",
    "n07007":"李崖主",
    "n20230":"徐暇客",
    "n80029":"燕槐",
    "n80033":"燕巧",
    "n80016":"赛伊尹",
    "n80120":"屠善宰",
    "n90201":"孔金",
    "n80030":"刁不易",
    "n53001":"黄裳",
    "n60040":"漆笑儿",
    "n60005":"李叹",
    "n60400":"程雁华",
    "n09997":"张君宝",
    "n90405":"何紫菀",
    "n50060":"鹰猎人首领",
    "n09999a":"「巫山神女」",
    "n09999b":"颜玉书",
    "n09996":"楚湘莲",
    "n60130":"司徒荆",
    "n60560":"颛孙凝",
    "n20033":"王喆",
    "n60273":"骆元玉",
    "n20049":"禾郁青",
    "n60402":"石鸿图",
    "n60106b":"容艳雪",
    "n60100":"樊香蝶",
    "n09996a":"百损",
    "n09998a":"神秘男子",
    "n10001":"石信",
    "n10003":"石老三",
    "n10004":"石老四",
    "n10005":"石老五",
    "n10006":"石老六",
    "n10015":"神态疯狂的流寇",
    "n10016":"神态疯狂的流寇",
    "n10017":"神态疯狂的流寇",
    "n10018":"神态疯狂的流寇",
    "n10019":"钓客 戚馆筵",
    "n10023":"狮子头 梅立",
    "n10024":"赛武松 吴胆",
    "n10025":"小花荣 步隼",
    "n10026":"凶恶的大虫",
    "n10027a":"豆花铺伙计",
    "n10028":"盐帮帮众 劳斯嵇",
    "n10038":"盐帮帮众",
    "n10039":"盐帮帮众 石瑾范",
    "n10043":"活扁鹊 伊史仁",
    "n10044a":"盐工",
    "n10044b":"盐帮帮众",
    "n10044c":"妇人",
    "n10044d":"商人",
    "n10045a":"苦难",
    "n10045b":"苦悲",
    "n10045c":"苦命",
    "n10045d":"苦难",
    "n10045e":"苦悲",
    "n10045f":"苦命",
    "n10046a":"带发头陀",
    "n10046b":"少林火工陈大智",
    "n10046c":"少林火工陈大智",
    "n10048":"猎户老王",
    "n10049":"樵夫老李",
    "n10055a":"夺命刀 孙修",
    "n10055b":"追魂剑 陈式",
    "n10055c":"毒阎罗 李硅",
    "n10055d":"翻江棍 曹应",
    "n10055e":"连环镖 萧潇",
    "n10055f":"开山掌 钱霸",
    "n10056a":"桃大",
    "n10057a":"桃二",
    "n10058a":"桃三",
    "n10059a":"桃四",
    "n10060a":"桃五",
    "n10061a":"桃六",
    "n10062a":"士兵",
    "n10062b":"士兵",
    "n10063a":"士兵",
    "n10063b":"士兵",
    "n10063c":"士兵",
    "n10063d":"士兵",
    "n10063e":"士兵",
    "n10063f":"士兵",
    "n10063g":"士兵",
    "n10063h":"士兵",
    "n10063i":"士兵",
    "n10063j":"士兵",
    "n10063k":"士兵",
    "n10063l":"士兵",
    "n10063m":"士兵",
    "n10063n":"士兵",
    "n10063o":"士兵",
    "n10063p":"士兵",
    "n10063q":"士兵",
    "n10064":"士兵",
    "n10066a":"士兵",
    "n10066b":"士兵",
    "n10066c":"士兵",
    "n10066d":"士兵",
    "n10068a":"士兵",
    "n10068b":"士兵",
    "n10068c":"士兵",
    "n10068d":"士兵",
    "n10068e":"士兵",
    "n10068f":"士兵",
    "n10068g":"士兵",
    "n10068h":"士兵",
    "n10068i":"士兵",
    "n10068j":"士兵",
    "n10069a":"伙夫",
    "n10070":"妇人",
    "n10071a":"随军郎中",
    "n10073a":"商人",
    "n10073b":"苦力",
    "n10073c":"苦力",
    "n10074":"平三平",
    "n10076":"军官",
    "n10078":"妇人",
    "n10079":"曹奉",
    "n10080":"粮商",
    "n10081a":"青城弟子",
    "n10082a":"洛许",
    "n10082b":"洛许",
    "n10082c":"洛许",
    "n10082d":"洛许",
    "n10083a":"步玺守",
    "n10083c":"步玺守",
    "n10084a":"丧门星 李鲧",
    "n10084b":"活太岁 萧漳",
    "n10084c":"穿林豺 李庆",
    "n10084d":"瞪眼彪 赵魁",
    "n10084e":"鬼见愁 曾丑",
    "n10085b":"黑衣客",
    "n10085c":"银颉",
    "n10087a":"李小妹",
    "n10088a":"神秘人",
    "n10088b":"神秘人",
    "n10088c":"神秘人",
    "n10088d":"神秘人",
    "n10088e":"神秘人",
    "n19971a":"豹王寨喽啰",
    "n19971b":"豹王寨喽啰",
    "n19971c":"豹王寨喽啰",
    "n19971d":"豹王寨喽啰",
    "n19971e":"豹王寨喽啰",
    "n19971f":"豹王寨喽啰",
    "n19971g":"豹王寨喽啰",
    "n19971h":"豹王寨喽啰",
    "n19971i":"豹王寨喽啰",
    "n19971j":"豹王寨喽啰",
    "n19971k":"豹王寨喽啰",
    "n19971m":"豹王寨喽啰",
    "n19971n":"豹王寨喽啰",
    "n19971o":"豹王寨喽啰",
    "n19971p":"豹王寨喽啰",
    "n19971q":"豹王寨喽啰",
    "n19976a":"韩猊跋",
    "n19977":"悍匪",
    "n19978":"悍匪",
    "n19979":"亡命之徒",
    "n19980":"亡命之徒",
    "n19981":"亡命之徒",
    "n19982":"土匪",
    "n19983":"土匪",
    "n19984":"土匪",
    "n19985":"流寇",
    "n19986":"流寇",
    "n19987":"流寇",
    "n19988":"迷恋火焰的流寇",
    "n19989":"迷恋火焰的山贼",
    "n19990":"迷恋火焰的土匪",
    "n19991":"迷恋火焰的要犯",
    "n19992":"迷恋火焰的强盗",
    "n19993":"锦毛虎",
    "n19994":"翻江虎",
    "n19995":"穿山虎",
    "n19996":"彻地虎",
    "n19997":"钻天虎",
    "n20000":"禾泓渊",
    "n20001":"禾家马帮帮众",
    "n20001b":"禾家马帮帮众",
    "n20001c":"禾嘉仁",
    "n20001d":"禾家马帮帮众",
    "n20001e":"禾家马帮帮众",
    "n60231":"梅星河",
    "n20016":"农夫 老黄",
    "n20025":"擎天寨守卫",
    "n20026":"擎天寨守卫",
    "n20026b":"擎天寨守卫",
    "n20027":"擎天寨守卫",
    "n20027b":"擎天寨守卫",
    "n20029":"擎天寨弓箭手",
    "n20029b":"擎天寨弓箭手",
    "n20029c":"擎天寨弓箭手",
    "n20029d":"擎天寨弓箭手",
    "n20029e":"擎天寨弓箭手",
    "n20029f":"擎天寨弓箭手",
    "n20029g":"擎天寨弓箭手",
    "n20029h":"擎天寨弓箭手",
    "n20029i":"擎天寨弓箭手",
    "n20029j":"擎天寨弓箭手",
    "n20029k":"擎天寨弓箭手",
    "n20029m":"擎天寨弓箭手",
    "n20029n":"擎天寨弓箭手",
    "n20029p":"擎天寨弓箭手",
    "n20030":"擎天寨众",
    "n20030b":"擎天寨众",
    "n20030c":"擎天寨众",
    "n20030d":"擎天寨众",
    "n20030e":"擎天寨众",
    "n20030f":"擎天寨众",
    "n20030g":"擎天寨众",
    "n20030h":"擎天寨众",
    "n20030i":"擎天寨众",
    "n20030j":"擎天寨众",
    "n20030k":"擎天寨众",
    "n20030m":"擎天寨众",
    "n20031":"擎天寨众",
    "n20031b":"擎天寨众",
    "n20031c":"擎天寨众",
    "n20031d":"擎天寨众",
    "n20031e":"擎天寨众",
    "n20031f":"擎天寨众",
    "n20031g":"擎天寨众",
    "n20031h":"擎天寨众",
    "n20031i":"擎天寨众",
    "n20031j":"擎天寨众",
    "n20031k":"擎天寨众",
    "n20031m":"擎天寨众",
    "n20032":"擎天寨巡逻兵",
    "n20032b":"擎天寨巡逻兵",
    "n20032c":"擎天寨巡逻兵",
    "n20032d":"擎天寨巡逻兵",
    "n20032e":"擎天寨巡逻兵",
    "n20032f":"擎天寨巡逻兵",
    "n20032g":"擎天寨巡逻兵",
    "n20032h":"擎天寨巡逻兵",
    "n20033b":"王喆",
    "n20033e":"王喆",
    "n20034":"擎天寨众",
    "n20034b":"擎天寨众",
    "n20039":"擎天寨众",
    "n20039b":"擎天寨众",
    "n20039f":"擎天寨众",
    "n20039e":"擎天寨众",
    "n20036":"擎天寨高手",
    "n20036b":"擎天寨众",
    "n20036c":"擎天寨众",
    "n20036d":"擎天寨众",
    "n20036e":"擎天寨众",
    "n20036f":"擎天寨弓箭手",
    "n20036g":"擎天寨弓箭手",
    "n20036h":"擎天寨弓箭手",
    "n20036i":"擎天寨弓箭手",
    "n20036j":"擎天寨弓箭手",
    "n20036k":"擎天寨弓箭手",
    "n20037":"战胤飞",
    "n20038":"擎天寨高手",
    "n20038b":"擎天寨高手",
    "n20039c":"擎天寨众",
    "n20039d":"擎天寨众",
    "n20039e_b":"擎天寨众",
    "n20039f_b":"擎天寨众",
    "n20039g":"擎天寨众",
    "n20039h":"擎天寨众",
    "n20039i":"擎天寨众",
    "n20039j":"擎天寨众",
    "n20039k":"擎天寨众",
    "n20039m":"擎天寨众",
    "n20045":"禾家马帮帮众",
    "n20046":"禾家马帮帮众",
    "n20050":"士兵",
    "n20051":"士兵",
    "n20052":"哨塔弓手",
    "n20052b":"哨塔弓手",
    "n20052c":"哨塔弓手",
    "n20052d":"哨塔弓手",
    "n20052e":"哨塔弓手",
    "n20052f":"哨塔弓手",
    "n20053":"士兵",
    "n20054":"士兵",
    "n20055":"士兵",
    "n20056":"士兵",
    "n20057":"士兵",
    "n20058":"士兵",
    "n20064":"算命仙",
    "n20065":"恶汉",
    "n20066":"民众",
    "n20070":"商人",
    "n20072":"商人",
    "n20073":"何掌柜",
    "n20074":"肉铺老板",
    "n20075":"毛皮铺老板",
    "n20076":"商人",
    "n20080":"民妇",
    "n20085":"叶家马帮帮众",
    "n20086":"叶家马帮帮众",
    "n20086c":"叶家马帮帮众",
    "n20087":"叶家马帮帮众",
    "n20087c":"叶家马帮帮众",
    "n20088":"叶家马帮帮众",
    "n20089":"叶家马帮帮众",
    "n20090":"叶家马帮帮众",
    "n20094":"鱼叟",
    "n20096":"酒馆小二",
    "n20098":"老人家",
    "n20099":"老婆婆",
    "n20102":"民女",
    "n20103":"民女",
    "n20106":"喇嘛",
    "n20107":"听经男子",
    "n20108":"听经女子",
    "n20109":"听经女子",
    "n20110":"听经男子",
    "n20110b":"听经女子",
    "n20112":"鲁布",
    "n20143":"煞手人寰",
    "n20120":"曹衍",
    "n20136":"苏天",
    "n20137":"叶玉龙",
    "n20138":"叶家马帮帮众",
    "n20139":"叶家马帮帮众",
    "n20140":"叶家马帮帮众",
    "n20141":"疤面煞星",
    "n20142":"凶神恶煞",
    "n20144":"大煞风景",
    "n20146":"叶金虹",
    "n20148":"叶家马帮帮众",
    "n20151":"禾家马帮帮众",
    "n20152":"禾家马帮帮众",
    "n20153":"禾家马帮帮众",
    "n20154":"劫匪",
    "n20155":"劫匪",
    "n20156":"劫匪",
    "n20157":"劫匪",
    "n20158":"劫匪",
    "n20159":"劫匪头领",
    "n20161":"擎天寨众",
    "n20161b":"擎天寨众",
    "n20165":"当铺掌柜",
    "n20167":"叶家马帮帮众",
    "n20168":"贾丁",
    "n20170":"武师",
    "n20171":"武师",
    "n20172":"流寇",
    "n20173":"流寇",
    "n20174":"流寇",
    "n20175":"流寇",
    "n20176":"流寇",
    "n20177":"流寇",
    "n20178":"流寇",
    "n20179":"流寇",
    "n20180":"流寇",
    "n20181":"流寇",
    "n20182":"流寇",
    "n20183":"流寇",
    "n20185":"流寇",
    "n20186":"流寇",
    "n20187":"流寇",
    "n20188b":"赵安",
    "n20191":"舒光壁",
    "n20192":"淘石帮众",
    "n20193":"淘石帮众",
    "n20194":"淘石帮众",
    "n20195":"淘石帮众",
    "n20202":"钓鱼翁",
    "n20203":"猎熊人",
    "n20204":"猎熊人",
    "n20205":"猎熊人",
    "n20206":"猎熊人",
    "n20211":"董府护卫",
    "n20212":"董府护卫",
    "n20213":"董府护卫",
    "n20214":"董府护卫",
    "n20215":"董府护卫",
    "n20216":"董府护卫",
    "n20217":"赵奶妈",
    "n20218":"婢女 剑儿",
    "n20219":"婢女 刀儿",
    "n20220":"婢女 枪儿",
    "n20225":"婢女 弓儿",
    "n20226":"董府护卫",
    "n20227":"董府护卫",
    "n20228":"董府护卫",
    "n20229":"罗老妈子",
    "n20231":"大研镇烧饼老板",
    "n20232":"大研镇水果店老板娘",
    "n20233":"大研镇卖菜老板",
    "n20234":"大研镇卖菜老板娘",
    "n20235":"大研镇鱼铺老板",
    "n20236":"大研镇糖葫芦",
    "n20240":"大研镇面摊老板",
    "n20241":"大研镇包子馒头",
    "n20242":"大研镇烤肉老板娘",
    "n20243":"柯比",
    "n20244":"大研镇武器铺",
    "n20245":"文淬之",
    "n20245b":"文淬之",
    "n20246":"解长宁",
    "n20246b":"解长宁",
    "n20247":"武林人士",
    "n20248":"武林人士",
    "n20257":"女子",
    "n20259":"青城弟子",
    "n20260":"妖道",
    "n20261":"妖道",
    "n20262":"妖道",
    "n20264":"山魈恶鬼",
    "n20265":"山魈恶鬼",
    "n20266":"山魈恶鬼",
    "n20267":"山魈恶鬼",
    "n20268":"山魈恶鬼",
    "n20269":"山魈恶鬼",
    "n20270":"山魈恶鬼",
    "n20271":"山魈恶鬼",
    "n20272":"山魈恶鬼",
    "n20273":"山魈恶鬼",
    "n20274":"山魈恶鬼",
    "n20275":"山魈恶鬼",
    "n20276":"山魈恶鬼",
    "n20277":"山魈恶鬼",
    "n20278":"山魈恶鬼",
    "n20279":"山魈恶鬼",
    "n20280":"山魈恶鬼",
    "n20281":"山魈恶鬼",
    "n20282":"山魈恶鬼",
    "n20283":"山魈恶鬼",
    "n20284":"山魈恶鬼",
    "n20286":"山魈鬼王",
    "n20287":"山魈恶鬼",
    "n20288":"山魈恶鬼",
    "n20289":"猎户",
    "n20310":"擎天寨众",
    "n20311":"擎天寨众",
    "n20312":"擎天寨众",
    "n20314":"擎天寨众",
    "n20315":"擎天寨众",
    "n20316":"擎天寨众",
    "n20317":"擎天寨众",
    "n20318":"擎天寨众",
    "n20319":"擎天寨众",
    "n20320":"擎天寨众",
    "n20321":"擎天寨众",
    "n20321b":"擎天寨众",
    "n20321c":"擎天寨众",
    "n20321d":"擎天寨众",
    "n20321e":"擎天寨众",
    "n20321f":"擎天寨众",
    "n20321g":"擎天寨众",
    "n20321h":"擎天寨众",
    "n20321j":"擎天寨众",
    "n20321k":"擎天寨众",
    "n20321m":"擎天寨众",
    "n20321n":"擎天寨众",
    "n20321p":"擎天寨众",
    "n20321q":"擎天寨众",
    "n20321r":"擎天寨众",
    "n20321s":"擎天寨众",
    "n20322":"擎天寨众",
    "n20323":"擎天寨众",
    "n20324":"擎天寨众",
    "n20325":"擎天寨众",
    "n20326":"擎天寨众",
    "n20327":"擎天寨众",
    "n20328":"擎天寨众",
    "n20329":"擎天寨众",
    "n20330":"流寇",
    "n20331":"流寇",
    "n20332":"流寇",
    "n20333":"流寇",
    "n20334":"流寇",
    "n20335":"流寇",
    "n20336":"流寇",
    "n20337":"流寇",
    "n20338":"流寇",
    "n20339":"流寇",
    "n20340":"流寇",
    "n20341":"流寇",
    "n20342":"流寇",
    "n20343":"流寇",
    "n20344":"流寇",
    "n20345":"流寇",
    "n20346":"流寇",
    "n20347":"流寇",
    "n20348":"流寇",
    "n20349":"流寇",
    "n20349b":"流寇",
    "n20350":"流寇",
    "n20350b":"流寇",
    "n20351":"流寇",
    "n20351b":"流寇",
    "n20352":"流寇",
    "n20352b":"流寇",
    "n20353":"流寇",
    "n20353b":"流寇",
    "n20354":"流寇",
    "n20354b":"流寇",
    "n20355":"豹王寨高手",
    "n20356":"豹王寨高手",
    "n20357":"豹王寨众",
    "n20358":"豹王寨众",
    "n20359":"豹王寨众",
    "n20363":"百夫长",
    "n20364":"狼蛮士兵",
    "n20365":"狼蛮士兵",
    "n20366":"狼蛮士兵",
    "n20367":"狼蛮士兵",
    "n20368":"狼蛮士兵",
    "n20369":"狼蛮士兵",
    "n20370":"狼蛮士兵",
    "n20372":"狼蛮士兵",
    "n20373":"狼蛮士兵",
    "n20374":"狼蛮士兵",
    "n20375":"狼蛮士兵",
    "n20376":"狼蛮士兵",
    "n20377":"狼蛮士兵",
    "n20378":"狼蛮士兵",
    "n20379":"狼蛮士兵",
    "n20380":"狼蛮士兵",
    "n20381":"狼蛮士兵",
    "n20382":"狼蛮士兵",
    "n20383":"狼蛮士兵",
    "n20384":"狼蛮士兵",
    "n20385":"狼蛮士兵",
    "n20386":"狼蛮士兵",
    "n20387":"十夫长",
    "n20388":"狼蛮士兵",
    "n20389":"狼蛮士兵",
    "n20390":"狼蛮士兵",
    "n20391":"狼蛮士兵",
    "n20396":"狼蛮士兵",
    "n20406":"十夫长",
    "n20407":"狼蛮兵",
    "n20408":"狼蛮兵",
    "n20409":"狼蛮兵",
    "n20410":"狼蛮兵",
    "n20411":"百夫长",
    "n20412":"狼蛮兵",
    "n20413":"狼蛮兵",
    "n20414":"狼蛮兵",
    "n20415":"狼蛮兵",
    "n20416":"狼蛮兵",
    "n20417":"狼蛮兵",
    "n20418":"狼蛮兵",
    "n20424":"狼蛮兵",
    "n20425":"狼蛮兵",
    "n20426":"狼蛮兵",
    "n20427":"狼蛮兵",
    "n20428":"狼蛮兵",
    "n20429":"狼蛮兵",
    "n20430":"狼蛮兵",
    "n20431":"狼蛮兵",
    "n20432":"狼蛮兵",
    "n20433":"狼蛮兵",
    "n20434":"狼蛮兵",
    "n20435":"狼蛮兵",
    "n20442":"狼蛮兵",
    "n20443":"狼蛮兵",
    "n20444":"狼蛮兵",
    "n20445":"狼蛮兵",
    "n20446":"狼蛮兵",
    "n20447":"狼蛮兵",
    "n20448":"狼蛮兵",
    "n20449":"狼蛮兵",
    "n20450":"狼蛮兵",
    "n20451":"百夫长",
    "n20452":"狼蛮兵",
    "n20453":"狼蛮兵",
    "n20454":"狼蛮兵",
    "n20455":"狼蛮兵",
    "n20462":"番僧",
    "n20463":"番僧",
    "n20464":"番僧",
    "n20465":"番僧",
    "n20466":"狼蛮兵",
    "n20467":"狼蛮兵",
    "n20468":"狼蛮兵",
    "n20471":"擎天寨众",
    "n20475":"狼蛮兵",
    "n20476":"狼蛮兵",
    "n20477":"狼蛮兵",
    "n20478":"狼蛮兵",
    "n20479":"狼蛮兵",
    "n20480":"狼蛮兵",
    "n20481":"狼蛮兵",
    "n20482":"狼蛮兵",
    "n20486":"狼蛮兵",
    "n20487":"狼蛮兵",
    "n20488":"十夫长",
    "n20489":"狼蛮兵",
    "n20490":"狼蛮兵",
    "n20491":"狼蛮兵",
    "n20492":"狼蛮兵",
    "n20493":"狼蛮兵",
    "n20494":"狼蛮兵",
    "n20495":"沈泽琦",
    "n20495b":"沈泽琦",
    "n20496":"士兵",
    "n20497":"士兵",
    "n20498":"士兵",
    "n20499":"士兵",
    "n20500":"士兵",
    "n20501":"士兵",
    "n20502":"士兵",
    "n20503":"士兵",
    "n20504":"士兵",
    "n20505":"士兵",
    "n20506":"士兵",
    "n20507":"士兵",
    "n20508":"士兵",
    "n20509":"士兵",
    "n20510":"夏札尔",
    "n20511":"番僧",
    "n20512":"番僧",
    "n20513":"狼蛮将军",
    "n20516":"狼蛮兵",
    "n20517":"狼蛮兵",
    "n20518":"狼蛮兵",
    "n20519":"狼蛮兵",
    "n20520":"狼蛮兵",
    "n20521":"狼蛮兵",
    "n20524":"狼蛮兵",
    "n20525":"狼蛮兵",
    "n20526":"狼蛮兵",
    "n20534":"老尼姑",
    "n20535":"无量剑派弟子",
    "n20536":"无量剑派弟子",
    "n20537":"无量剑派弟子",
    "n20538":"无量剑派弟子",
    "n20539":"无量剑派弟子",
    "n20540":"无量剑派弟子",
    "n20541":"无量剑派弟子",
    "n20542":"挖掘工人",
    "n20543":"挖掘工人",
    "n20544":"挖掘工人",
    "n20545":"挖掘工人",
    "n20546":"挖掘工人",
    "n20547":"挖掘工人",
    "n20548":"挖掘工人",
    "n20554":"缇骑",
    "n20555":"缇骑",
    "n20556":"缇骑",
    "n20557":"缇骑",
    "n20558":"缇骑",
    "n20559":"缇骑",
    "n20560":"缇骑",
    "n20561":"缇骑",
    "n60340":"锦衣卫指挥使 张又沉",
    "n50004":"桑登",
    "n90425b":"杨天义",
    "n20583":"丐帮长老",
    "n20584":"丐帮弟子",
    "n20585":"丐帮弟子",
    "n20586b":"无名老僧",
    "n20586":"无名老僧",
    "n20606":"勇虎",
    "n20607":"狼蛮士兵",
    "n20608":"狼蛮士兵",
    "n20609":"狼蛮士兵",
    "n20610":"百夫长",
    "n20611":"狼蛮士兵",
    "n20612":"狼蛮士兵",
    "n20613":"百夫长",
    "n20614":"狼蛮士兵",
    "n20615":"胜豹",
    "n20618":"青海番僧",
    "n20619":"青海番僧",
    "n20620":"狼蛮士兵",
    "n20621":"狼蛮士兵",
    "n20622":"狼蛮士兵",
    "n20623":"昙狮",
    "n20624":"百夫长",
    "n20625":"狼蛮士兵",
    "n20626":"狼蛮士兵",
    "n20627":"狼蛮士兵",
    "n20631":"宝象",
    "n20632":"百夫长",
    "n20633":"狼蛮士兵",
    "n20634":"狼蛮士兵",
    "n20635":"狼蛮士兵",
    "n20636":"持龙",
    "n20642":"狼蛮士兵",
    "n20643":"百夫长",
    "n20644":"百夫长",
    "n20645":"狼蛮士兵",
    "n20650":"慈荫师太",
    "n20651":"流寇",
    "n20656":"无量剑派掌门",
    "n21008":"灰狼",
    "n21009":"灰狼",
    "n21010":"灰狼",
    "n21011":"灰狼",
    "n21012":"灰狼",
    "n21013":"灰狼",
    "n21014":"灰狼",
    "n21015":"灰狼",
    "n21016":"灰狼",
    "n21017":"灰狼",
    "n21018":"灰狼",
    "n21019":"灰狼",
    "n21020":"灰狼",
    "n21021":"灰狼",
    "n21022":"灰狼",
    "n21023":"灰狼",
    "n21024":"灰狼",
    "n21025":"雪狼",
    "n21027":"灰狼",
    "n21028":"灰狼",
    "n21029":"灰狼",
    "n21030":"灰狼",
    "n21031":"灰狼",
    "n21032":"灰狼",
    "n21033":"灰狼",
    "n21034":"灰狼",
    "n21035":"灰狼",
    "n21036":"灰狼",
    "n21037":"灰狼",
    "n21038":"灰狼",
    "n21039":"灰狼",
    "n21040":"灰狼",
    "n21041":"灰狼",
    "n21042":"灰狼",
    "n21043":"灰狼",
    "n21044":"灰狼",
    "n21045":"灰狼",
    "n21046":"灰狼",
    "n21047":"灰狼",
    "n21048":"灰狼",
    "n21051":"花豹",
    "n21052":"熊",
    "n21053":"吃人熊",
    "n21054":"蛇王",
    "n21055":"毒蛇",
    "n21056":"毒蛇",
    "n21057":"毒蛇",
    "n21058":"毒蛇",
    "n21059":"毒蛇",
    "n21064":"毒蛇",
    "n21065":"毒蛇",
    "n21066":"毒蛇",
    "n21067":"毒蛇",
    "n21068":"毒蛇",
    "n21069":"毒蛇",
    "n21076":"毒蛇",
    "n21077":"毒蛇",
    "n21078":"毒蛇",
    "n21079":"毒蛇",
    "n21080":"大鳄鱼",
    "n21084":"大鳄鱼",
    "n21085":"大鳄鱼",
    "n21086":"大鳄鱼",
    "n21087":"大鳄鱼",
    "n21091":"白虎",
    "n21092":"鳄鱼",
    "n21093":"鳄鱼",
    "n21094":"鳄鱼",
    "n21095":"鳄鱼",
    "n21096":"鳄鱼",
    "n21097":"鳄鱼",
    "n21098":"鳄鱼",
    "n21099":"鳄鱼",
    "n21100":"鳄鱼",
    "n21101":"鳄鱼",
    "n21102":"鳄鱼",
    "n21103":"鳄鱼",
    "n21104":"鳄鱼",
    "n21105":"鳄鱼",
    "n21106":"鳄鱼",
    "n21107":"鳄鱼",
    "n21108":"鳄鱼",
    "n21109":"鳄鱼",
    "n21110":"鳄鱼",
    "n21111":"鳄鱼",
    "n21112":"鳄鱼",
    "n21113":"鳄鱼",
    "n21114":"鳄鱼",
    "n21115":"鳄鱼",
    "n21116":"鳄鱼",
    "n21117":"鳄鱼",
    "n21118":"鳄鱼",
    "n21120":"熊",
    "n21121":"熊",
    "n21122":"雪狼",
    "n21123":"雪狼",
    "n21124":"雪狼",
    "n21125":"兽王 白牙",
    "n21125_a01":"兽王 白牙",
    "n21125_a02":"兽王 白牙",
    "n21125_a03":"兽王 白牙",
    "n21125_a04":"兽王 白牙",
    "n21125_a05":"兽王 白牙",
    "n21126":"雪狼",
    "n21127":"雪狼",
    "n21128":"雪狼",
    "n21129":"花豹",
    "n21130":"花豹",
    "n21131":"山羊",
    "n22012":"马",
    "n23005":"武学障(拙)",
    "n23006":"武学障(静)",
    "n23007":"武学障(柔)",
    "n23008":"武学障(巧)",
    "n23010":"武学障(刚)",
    "n30002":"赵擎",
    "n30004":"邵谦",
    "n30005":"邵如珏",
    "n30006":"淘石帮 金英",
    "n30007":"淘石帮 吕兆",
    "n30008":"淘石帮 晁大河",
    "n30009":"淘石帮 宋元德",
    "n30010":"淘石工 陈干",
    "n30016":"江馥",
    "n30021":"工头 王哥",
    "n30022":"查大娘",
    "n30023":"查阿牛",
    "n30024":"叶萍",
    "n30025":"吴叫化",
    "n30028":"于兴和",
    "n30029":"于兴平",
    "n30051":"醉汉 老梅",
    "n30053":"汪治枣",
    "n30055":"晏伯",
    "n30057":"樵夫 卢铁华",
    "n30061":"云游郎中",
    "n30069":"殷雄",
    "n30072":"怪僧",
    "n30073":"姚狠",
    "n30074":"姚忠",
    "n30075":"姚孝",
    "n30076":"姚仁",
    "n30077":"姚义",
    "n30078":"姚全德",
    "n50001":"扫地寺僧",
    "n50002":"阿胡阿山",
    "n50007":"僧侣 才曲",
    "n50009":"讲道的喇嘛",
    "n50011":"镇民 和阿正",
    "n50012":"商人",
    "n50013":"索巴南卓",
    "n50013b":"索巴南卓",
    "n50013c":"索巴南卓",
    "n50014":"勘卓伦登",
    "n50015":"僧侣 札德",
    "n50020a":"巨熊",
    "n50020b":"野豹",
    "n50020c":"大老虎",
    "n50022":"僧侣 札达",
    "n50024":"贝玛却札",
    "n50030":"僧侣 邓珠",
    "n50043":"行迹可疑的人",
    "n50048":"纳西贵族",
    "n50049":"李连",
    "n50050":"阿九",
    "n50051":"黑衣人",
    "n50055":"鹰猎人阿季",
    "n50056b":"鹰猎人",
    "n50056c":"鹰猎人",
    "n50057":"猎鹰",
    "n50061":"雪豹",
    "n50062":"流寇打手",
    "n50065":"木奎",
    "n50065b":"语调刚硬的男人",
    "n50074":"站岗士兵",
    "n50070":"雪翼雕",
    "n50070b":"雪翼雕",
    "n50070c":"雪翼雕",
    "n50070d":"雪翼雕",
    "n50070e":"雪翼雕",
    "n50071":"老者",
    "n50073a2":"图勒",
    "n50076":"打更士兵",
    "n50077":"打更士兵",
    "n50080":"打更士兵",
    "n50101":"战斗测试员",
    "n50102":"战斗测试兵一号",
    "n50103":"战斗测试兵二号",
    "n50104":"木府卫兵阿单",
    "n50152bm":"鬼刀小弟 吴良",
    "n50152cm":"鬼刀小弟 吴辛",
    "n50152m":"鬼刀 吴仁",
    "n50153b":"守门卫兵",
    "n50153c":"守门卫兵",
    "n51002":"卖药郎中",
    "n51003":"村民",
    "n51005":"村民",
    "n51006":"村民",
    "n51007":"村民",
    "n51009":"何白芍",
    "n51010":"受伤的男子",
    "n52003a":"黑衣人",
    "n52003b":"黑衣人",
    "n52003c":"黑衣人",
    "n52003d":"黑衣人",
    "n52005a":"黑衣人",
    "n52005b":"黑衣人",
    "n52005c":"黑衣人",
    "n52005d":"黑衣人",
    "n52005e":"黑衣人",
    "n52006a":"黑衣人",
    "n52006b":"黑衣人",
    "n52006c":"黑衣人",
    "n52006d":"黑衣人",
    "n52007":"猎犬",
    "n52008a":"商人",
    "n52008b":"家丁",
    "n52008c":"茶庄伙计",
    "n52008d":"茶庄伙计",
    "n52009":"黑衣女子",
    "n52010a":"黑衣人",
    "n52010b":"黑衣人",
    "n52010c":"黑衣人",
    "n52012e":"木府弓箭手",
    "n52012f":"木府弓箭手",
    "n52012g":"木府精锐弓箭手",
    "n52013e":"白衣派僧侣",
    "n52017":"阿喜阿加",
    "n52017b":"阿从阿季",
    "n52017c":"阿泰阿席",
    "n52017d-2":"阿从阿延",
    "n52017e":"阿满阿天",
    "n52017f":"阿西阿贡",
    "n52021":"图勒",
    "n52021c-1":"黑衣人",
    "n52021c-2":"黑衣人",
    "n52021c-3":"黑衣人",
    "n52025":"鹰猎人阿季",
    "n52025b":"鹰猎人阿席",
    "n52025c":"鹰猎人",
    "n52025d":"噶玛寺僧侣",
    "n52025e":"噶玛寺僧侣",
    "n52025f":"噶玛寺僧侣",
    "n52025g":"噶玛寺僧侣",
    "n52025h":"噶玛寺僧侣",
    "n52025i":"噶玛寺僧侣",
    "n52025j":"噶玛寺僧侣",
    "n52025k":"噶玛寺僧侣",
    "n52027":"木府长枪兵",
    "n52027b":"木府长枪兵",
    "n52027c":"木府弓箭手",
    "n52027d":"木府弓箭手",
    "n52027e":"木府长枪兵",
    "n52027f":"木府长枪兵",
    "n52027g":"木府弓箭手",
    "n52027h":"木府弓箭手",
    "n52028":"木府侍卫 阿简",
    "n53005":"青城弟子",
    "n53005b":"青城弟子",
    "n53005c":"青城弟子",
    "n53005d":"青城弟子",
    "n53005e":"青城弟子",
    "n53005f":"青城弟子",
    "n53005g":"青城弟子",
    "n53005h":"青城弟子",
    "n53005i":"青城弟子",
    "n53005j":"青城弟子",
    "n53006":"明教老者",
    "n53006b":"明教老者",
    "n53006c":"明教老妇",
    "n53006d":"明教老妇",
    "n53006e":"明教女子",
    "n53006f":"明教伤众",
    "n53006g":"明教伤众",
    "n53006h":"明教伤众",
    "n53007":"明教教众",
    "n53007b":"明教教众",
    "n53007c":"明教教众",
    "n53007d":"明教教众",
    "n53007e":"明教教众",
    "n53007f":"明教教众",
    "n53007g":"明教教众",
    "n53008":"武人",
    "n53008b":"狼",
    "n53008c":"狼",
    "n53008d":"狼",
    "n53009":"青城弟子",
    "n53009b":"青城弟子",
    "n53010":"武人",
    "n53010b":"武人",
    "n53010c":"武人",
    "n53010d":"武人",
    "n53010e":"武人",
    "n53010f":"武人",
    "n53010g":"武人",
    "n53010h":"武人",
    "n53010i":"武人",
    "n53010j":"武人",
    "n53010k":"武人",
    "n53010l":"武人",
    "n53010m":"武人",
    "n53010n":"武人",
    "n54001_01":"商人",
    "n54001_02":"黑衣人",
    "n54001_02b":"黑衣人",
    "n54001_02c":"黑衣人",
    "n54001_02d":"黑衣人",
    "n54001_02e":"黑衣人",
    "n54002_01":"猎人",
    "n54002_02":"黑衣人",
    "n54002_02b":"黑衣人",
    "n54002_02c":"黑衣人",
    "n54003_01":"黑衣人",
    "n54003_01a":"黑衣人",
    "n54003_01b":"黑衣人",
    "n54003_01c":"黑衣人",
    "n54003_02":"报信黑衣人",
    "n54004_01":"豹王寨众",
    "n54004_01b":"豹王寨众",
    "n54004_01c":"豹王寨众",
    "n54004_02":"黑衣人",
    "n54004_02b":"黑衣人",
    "n54004_02c":"黑衣人",
    "n54004b_01":"豹王寨众",
    "n54004b_01b":"豹王寨众",
    "n54004b_01c":"豹王寨众",
    "n54004b_02":"黑衣人",
    "n54004b_02b":"黑衣人",
    "n54004b_02c":"黑衣人",
    "n54004c_01":"豹王寨众",
    "n54004c_01b":"豹王寨众",
    "n54004c_01c":"豹王寨众",
    "n54004c_02":"黑衣人",
    "n54004c_02b":"黑衣人",
    "n54004c_02c":"黑衣人",
    "n54005_01":"山魈恶鬼",
    "n54005_01b":"山魈恶鬼",
    "n54005_01c":"山魈恶鬼",
    "n54005_02":"黑衣人",
    "n54005_02b":"黑衣人",
    "n54005_02c":"黑衣人",
    "n50071b":"老者",
    "n55001":"流寇老大 大刀",
    "n55001b":"流寇 二刀",
    "n55001c":"流寇 三刀",
    "n55001d":"流寇 四刀",
    "n55001e":"流寇 五刀",
    "n55003":"流寇老大 大刀",
    "n55003b":"流寇 二刀",
    "n55003c":"流寇 三刀",
    "n55003d":"流寇 四刀",
    "n55003e":"流寇 五刀",
    "n55003f":"流寇 六刀",
    "n55003g":"流寇 七刀",
    "n55003h":"流寇 八刀",
    "n55004":"流寇老大 大棍",
    "n55004b":"流寇 二棍",
    "n55004c":"流寇 三棍",
    "n55004d":"流寇 四棍",
    "n55004e":"流寇 五棍",
    "n55004f":"流寇 六棍",
    "n55004g":"流寇 七棍",
    "n55004h":"流寇 八棍",
    "n55005":"流寇老大 飞箭",
    "n55005b":"流寇 二箭",
    "n55005c":"流寇 三箭",
    "n55005d":"流寇 四箭",
    "n55005e":"流寇 五箭",
    "n55005f":"流寇 六箭",
    "n55005g":"流寇 七箭",
    "n55005h":"流寇 八箭",
    "n55006":"流寇老大 飞刀",
    "n55006b":"流寇 二刀",
    "n55006c":"流寇 三刀",
    "n55006d":"流寇 四刀",
    "n55006e":"流寇 五刀",
    "n55006f":"流寇 六刀",
    "n55006g":"流寇 七刀",
    "n55006h":"流寇 八刀",
    "n56001":"老僧",
    "n59001":"兽王 红斑",
    "n59001_a01":"兽王 红斑",
    "n59001_a02":"兽王 红斑",
    "n59001_a03":"兽王 红斑",
    "n59001_a04":"兽王 红斑",
    "n59001_a05":"兽王 红斑",
    "n59001_D01":"鳄鱼",
    "n59001_D03":"鳄鱼",
    "n59001_D07":"鳄鱼",
    "n59001_D54":"鳄鱼",
    "n59001_D55":"鳄鱼",
    "n59001_D56":"鳄鱼",
    "n59001_D63":"鳄鱼",
    "n59001_D64":"鳄鱼",
    "n59001_D65":"鳄鱼",
    "n59001_D66":"鳄鱼",
    "n59001_D67":"鳄鱼",
    "n59001_D68":"鳄鱼",
    "n59001_N118":"大鳄鱼",
    "n59001_N119":"大鳄鱼",
    "n59001_N120":"大鳄鱼",
    "n59001_N43":"大鳄鱼",
    "n59001_N44":"大鳄鱼",
    "n59001_N45":"大鳄鱼",
    "n59001_N46":"大鳄鱼",
    "n59001_N47":"大鳄鱼",
    "n59001_N54":"大鳄鱼",
    "n59001_N55":"大鳄鱼",
    "n59001_N56":"大鳄鱼",
    "n59001_N57":"大鳄鱼",
    "n59001b":"红纹鳄鱼",
    "n59001c":"红纹鳄鱼",
    "n59001d":"兽王 白纹",
    "n59001d_001":"兽王 白纹",
    "n59001d_002":"兽王 白纹",
    "n59001d_003":"兽王 白纹",
    "n59001d_004":"兽王 白纹",
    "n59001d_005":"兽王 白纹",
    "n59001e":"白纹鳄鱼",
    "n59001f":"白纹鳄鱼",
    "n59002":"兽王 暴牙",
    "n59002_001":"大灰狼",
    "n59002_002":"灰狼",
    "n59002_003":"灰狼",
    "n59002_004":"灰狼",
    "n59002_005":"灰狼",
    "n59002_011":"大灰狼",
    "n59002_012":"灰狼",
    "n59002_013":"灰狼",
    "n59002_014":"灰狼",
    "n59002_015":"灰狼",
    "n59002_021":"大灰狼",
    "n59002_022":"灰狼",
    "n59002_023":"灰狼",
    "n59002_031":"大灰狼",
    "n59002_032":"灰狼",
    "n59002_033":"灰狼",
    "n59002_034":"灰狼",
    "n59002_041":"大灰狼",
    "n59002_042":"灰狼",
    "n59002_043":"灰狼",
    "n59002_044":"灰狼",
    "n59002_045":"灰狼",
    "n59002_046":"灰狼",
    "n59002_051":"大灰狼",
    "n59002_052":"灰狼",
    "n59002_053":"灰狼",
    "n59002_054":"灰狼",
    "n59002_061":"大灰狼",
    "n59002_062":"灰狼",
    "n59002_063":"灰狼",
    "n59002_064":"灰狼",
    "n59002_065":"灰狼",
    "n59002_066":"灰狼",
    "n59002_071":"大灰狼",
    "n59002_072":"灰狼",
    "n59002_073":"灰狼",
    "n59002_074":"灰狼",
    "n59002_081":"大灰狼",
    "n59002_082":"灰狼",
    "n59002_083":"灰狼",
    "n59002_091":"大灰狼",
    "n59002_092":"灰狼",
    "n59002_093":"灰狼",
    "n59002_094":"灰狼",
    "n59002_095":"灰狼",
    "n59002_101":"大灰狼",
    "n59002_102":"大灰狼",
    "n59002_103":"灰狼",
    "n59002_104":"灰狼",
    "n59002_105":"灰狼",
    "n59002_111":"大灰狼",
    "n59002_112":"大灰狼",
    "n59002_113":"灰狼",
    "n59002_114":"灰狼",
    "n59002_115":"灰狼",
    "n59002_121":"大灰狼",
    "n59002_122":"大灰狼",
    "n59002_123":"灰狼",
    "n59002_124":"灰狼",
    "n59002_125":"灰狼",
    "n59002_131":"大灰狼",
    "n59002_132":"灰狼",
    "n59002_133":"灰狼",
    "n59002_141":"大灰狼",
    "n59002_142":"灰狼",
    "n59002_143":"灰狼",
    "n59002_144":"灰狼",
    "n59002_151":"大灰狼",
    "n59002_152":"大灰狼",
    "n59002_153":"灰狼",
    "n59002_154":"灰狼",
    "n59002_155":"灰狼",
    "n59002_161":"大灰狼",
    "n59002_162":"大灰狼",
    "n59002_163":"灰狼",
    "n59002_164":"灰狼",
    "n59002_165":"灰狼",
    "n59002_166":"灰狼",
    "n59002_171":"大灰狼",
    "n59002_172":"大灰狼",
    "n59002_173":"灰狼",
    "n59002_174":"灰狼",
    "n59002_175":"灰狼",
    "n59002_181":"大灰狼",
    "n59002_182":"大灰狼",
    "n59002_183":"灰狼",
    "n59002_184":"灰狼",
    "n59002_185":"灰狼",
    "n59002_191":"大灰狼",
    "n59002_192":"灰狼",
    "n59002_193":"灰狼",
    "n59002_194":"灰狼",
    "n59002_201":"大灰狼",
    "n59002_202":"大灰狼",
    "n59002_203":"灰狼",
    "n59002_204":"灰狼",
    "n59002_205":"灰狼",
    "n59002_206":"灰狼",
    "n59002_211":"大灰狼",
    "n59002_212":"灰狼",
    "n59002_213":"灰狼",
    "n59002_214":"灰狼",
    "n59002_221":"大灰狼",
    "n59002_222":"大灰狼",
    "n59002_223":"灰狼",
    "n59002_224":"灰狼",
    "n59002_231":"大灰狼",
    "n59002_232":"大灰狼",
    "n59002_233":"灰狼",
    "n59002_234":"灰狼",
    "n59002_241":"大灰狼",
    "n59002_242":"灰狼",
    "n59002_243":"灰狼",
    "n59002_244":"灰狼",
    "n59002_245":"灰狼",
    "n59002_251":"大灰狼",
    "n59002_252":"大灰狼",
    "n59002_253":"灰狼",
    "n59002_254":"灰狼",
    "n59002_255":"灰狼",
    "n59002_261":"大灰狼",
    "n59002_262":"大灰狼",
    "n59002_263":"灰狼",
    "n59002_264":"灰狼",
    "n59002_265":"灰狼",
    "n59002_271":"大灰狼",
    "n59002_272":"灰狼",
    "n59002_273":"灰狼",
    "n59002_274":"灰狼",
    "n59002_281":"大灰狼",
    "n59002_282":"大灰狼",
    "n59002_283":"灰狼",
    "n59002_284":"灰狼",
    "n59002_291":"大灰狼",
    "n59002_292":"灰狼",
    "n59002_293":"灰狼",
    "n59002_294":"灰狼",
    "n59002_301":"大灰狼",
    "n59002_302":"大灰狼",
    "n59002_303":"灰狼",
    "n59002_304":"灰狼",
    "n59002_305":"灰狼",
    "n59002_306":"灰狼",
    "n59002_307":"灰狼",
    "n59002_308":"灰狼",
    "n59002_311":"大雪狼",
    "n59002_312":"雪狼",
    "n59002_313":"灰狼",
    "n59002_314":"灰狼",
    "n59002_321":"大雪狼",
    "n59002_322":"灰狼",
    "n59002_323":"雪狼",
    "n59002_324":"灰狼",
    "n59002_331":"大雪狼",
    "n59002_332":"雪狼",
    "n59002_333":"灰狼",
    "n59002_334":"雪狼",
    "n59002_341":"大雪狼",
    "n59002_342":"大雪狼",
    "n59002_343":"灰狼",
    "n59002_344":"雪狼",
    "n59002_345":"灰狼",
    "n59002_351":"大雪狼",
    "n59002_352":"大雪狼",
    "n59002_353":"灰狼",
    "n59002_354":"雪狼",
    "n59002_361":"大雪狼",
    "n59002_362":"大雪狼",
    "n59002_363":"雪狼",
    "n59002_364":"雪狼",
    "n59002_365":"雪狼",
    "n59002_371":"大雪狼",
    "n59002_372":"雪狼",
    "n59002_373":"雪狼",
    "n59002_374":"雪狼",
    "n59002_381":"大雪狼",
    "n59002_382":"雪狼",
    "n59002_383":"雪狼",
    "n59002_384":"雪狼",
    "n59002_391":"大雪狼",
    "n59002_392":"大雪狼",
    "n59002_393":"雪狼",
    "n59002_394":"雪狼",
    "n59002_395":"雪狼",
    "n59002_401":"大雪狼",
    "n59002_402":"大雪狼",
    "n59002_403":"雪狼",
    "n59002_404":"雪狼",
    "n59002_405":"雪狼",
    "n59002_406":"雪狼",
    "n59002_407":"雪狼",
    "n59002_408":"雪狼",
    "n59002_411":"大灰狼",
    "n59002_412":"灰狼",
    "n59002_413":"灰狼",
    "n59002_414":"灰狼",
    "n59002_421":"大灰狼",
    "n59002_422":"大灰狼",
    "n59002_423":"大灰狼",
    "n59002_424":"灰狼",
    "n59002_425":"灰狼",
    "n59002_431":"大灰狼",
    "n59002_432":"大灰狼",
    "n59002_433":"灰狼",
    "n59002_434":"灰狼",
    "n59002_435":"灰狼",
    "n59002_436":"灰狼",
    "n59002_441":"大灰狼",
    "n59002_442":"大灰狼",
    "n59002_443":"大灰狼",
    "n59002_444":"灰狼",
    "n59002_445":"灰狼",
    "n59002_446":"灰狼",
    "n59002_447":"灰狼",
    "n59002_448":"灰狼",
    "n59002_449":"灰狼",
    "n59002_451":"大灰狼",
    "n59002_452":"大灰狼",
    "n59002_453":"灰狼",
    "n59002_454":"灰狼",
    "n59002_455":"灰狼",
    "n59002_456":"灰狼",
    "n59002_461":"大灰狼",
    "n59002_462":"大灰狼",
    "n59002_463":"大灰狼",
    "n59002_464":"灰狼",
    "n59002_465":"灰狼",
    "n59002_466":"灰狼",
    "n59002_467":"灰狼",
    "n59002_468":"灰狼",
    "n59002_469":"灰狼",
    "n59002_471":"大灰狼",
    "n59002_472":"大灰狼",
    "n59002_473":"灰狼",
    "n59002_474":"灰狼",
    "n59002_475":"灰狼",
    "n59002_481":"大灰狼",
    "n59002_482":"大灰狼",
    "n59002_483":"灰狼",
    "n59002_484":"灰狼",
    "n59002_485":"灰狼",
    "n59002_486":"灰狼",
    "n59002_491":"大灰狼",
    "n59002_492":"大灰狼",
    "n59002_493":"大灰狼",
    "n59002_494":"灰狼",
    "n59002_495":"灰狼",
    "n59002_496":"灰狼",
    "n59002_497":"灰狼",
    "n59002_501":"大灰狼",
    "n59002_502":"大灰狼",
    "n59002_503":"灰狼",
    "n59002_504":"灰狼",
    "n59002_505":"灰狼",
    "n59002_506":"灰狼",
    "n59002_507":"灰狼",
    "n59002_508":"灰狼",
    "n59002_511":"大灰狼",
    "n59002_512":"大灰狼",
    "n59002_513":"大灰狼",
    "n59002_514":"灰狼",
    "n59002_515":"灰狼",
    "n59002_521":"大灰狼",
    "n59002_522":"大灰狼",
    "n59002_523":"灰狼",
    "n59002_524":"灰狼",
    "n59002_525":"灰狼",
    "n59002_531":"大灰狼",
    "n59002_532":"大灰狼",
    "n59002_533":"灰狼",
    "n59002_534":"灰狼",
    "n59002_535":"灰狼",
    "n59002_541":"大灰狼",
    "n59002_542":"灰狼",
    "n59002_543":"灰狼",
    "n59002_544":"灰狼",
    "n59002_551":"大灰狼",
    "n59002_552":"大灰狼",
    "n59002_553":"大灰狼",
    "n59002_554":"灰狼",
    "n59002_555":"灰狼",
    "n59002_556":"灰狼",
    "n59002_557":"灰狼",
    "n59002_561":"大灰狼",
    "n59002_562":"大灰狼",
    "n59002_563":"灰狼",
    "n59002_564":"灰狼",
    "n59002_565":"灰狼",
    "n59002_571":"大灰狼",
    "n59002_572":"大灰狼",
    "n59002_573":"灰狼",
    "n59002_574":"灰狼",
    "n59002_575":"灰狼",
    "n59002_576":"灰狼",
    "n59002_581":"大灰狼",
    "n59002_582":"大灰狼",
    "n59002_583":"大灰狼",
    "n59002_584":"灰狼",
    "n59002_585":"灰狼",
    "n59002_586":"灰狼",
    "n59002_591":"大灰狼",
    "n59002_592":"大灰狼",
    "n59002_593":"灰狼",
    "n59002_594":"灰狼",
    "n59002_595":"灰狼",
    "n59002_596":"灰狼",
    "n59002_601":"大灰狼",
    "n59002_6010":"灰狼",
    "n59002_6011":"灰狼",
    "n59002_6012":"灰狼",
    "n59002_6013":"灰狼",
    "n59002_6014":"灰狼",
    "n59002_602":"大灰狼",
    "n59002_603":"大灰狼",
    "n59002_604":"大灰狼",
    "n59002_605":"灰狼",
    "n59002_606":"灰狼",
    "n59002_607":"灰狼",
    "n59002_608":"灰狼",
    "n59002_609":"灰狼",
    "n59002_a01":"兽王 暴牙",
    "n59002_a02":"兽王 暴牙",
    "n59002_a03":"兽王 暴牙",
    "n59002_a04":"兽王 暴牙",
    "n59002_a05":"兽王 暴牙",
    "n59002b":"黑狼",
    "n59002c":"黑狼",
    "n59002d":"黑狼",
    "n59002e":"黑狼",
    "n59003":"兽王 寡妇制造者",
    "n59003_001":"野猪",
    "n59003_002":"野猪",
    "n59003_003":"野猪",
    "n59003_004":"野猪",
    "n59003_005":"野猪",
    "n59003_006":"野猪",
    "n59003_007":"野猪",
    "n59003_008":"野猪",
    "n59003_009":"野猪",
    "n59003_010":"野猪",
    "n59003_011":"野猪",
    "n59003_012":"野猪",
    "n59003_013":"野猪",
    "n59003_014":"野猪",
    "n59003_015":"野猪",
    "n59003_016":"野猪",
    "n59003_017":"野猪",
    "n59003_018":"野猪",
    "n59003_019":"野猪",
    "n59003_020":"野猪",
    "n59003_021":"野猪",
    "n59003_022":"野猪",
    "n59003_023":"野猪",
    "n59003_024":"野猪",
    "n59003_025":"野猪",
    "n59003_026":"野猪",
    "n59003_027":"野猪",
    "n59003_028":"野猪",
    "n59003_029":"野猪",
    "n59003_030":"野猪",
    "n59003_031":"野猪",
    "n59003_032":"野猪",
    "n59003_033":"野猪",
    "n59003_034":"野猪",
    "n59003_035":"野猪",
    "n59003_036":"野猪",
    "n59003_037":"野猪",
    "n59003_038":"野猪",
    "n59003_039":"野猪",
    "n59003_040":"野猪",
    "n59003_041":"野猪",
    "n59003_042":"野猪",
    "n59003_043":"野猪",
    "n59003_044":"野猪",
    "n59003_045":"野猪",
    "n59003_046":"野猪",
    "n59003_047":"野猪",
    "n59003_048":"野猪",
    "n59003_049":"野猪",
    "n59003_050":"野猪",
    "n59003_051":"野猪",
    "n59003_052":"野猪",
    "n59003_053":"野猪",
    "n59003_054":"野猪",
    "n59003_055":"野猪",
    "n59003_056":"野猪",
    "n59003_057":"野猪",
    "n59003_058":"野猪",
    "n59003_059":"野猪",
    "n59003_060":"野猪",
    "n59003_061":"野猪",
    "n59003_062":"野猪",
    "n59003_063":"野猪",
    "n59003_064":"野猪",
    "n59003_065":"野猪",
    "n59003_066":"野猪",
    "n59003_067":"野猪",
    "n59003_068":"野猪",
    "n59003_069":"野猪",
    "n59003_070":"野猪",
    "n59003_071":"野猪",
    "n59003_072":"野猪",
    "n59003_073":"野猪",
    "n59003_074":"野猪",
    "n59003_075":"野猪",
    "n59003_076":"野猪",
    "n59003_077":"野猪",
    "n59003_078":"野猪",
    "n59003_079":"野猪",
    "n59003_080":"野猪",
    "n59003_081":"野猪",
    "n59003_082":"野猪",
    "n59003_083":"野猪",
    "n59003_084":"野猪",
    "n59003_085":"野猪",
    "n59003_086":"野猪",
    "n59003_087":"野猪",
    "n59003_088":"野猪",
    "n59003_089":"野猪",
    "n59003_090":"野猪",
    "n59003_091":"野猪",
    "n59003_092":"野猪",
    "n59003_093":"野猪",
    "n59003_094":"野猪",
    "n59003_095":"野猪",
    "n59003_096":"野猪",
    "n59003_097":"野猪",
    "n59003_098":"野猪",
    "n59003_099":"野猪",
    "n59003_100":"野猪",
    "n59003_a01":"兽王 寡妇制造者",
    "n59003_a02":"兽王 寡妇制造者",
    "n59003_a03":"兽王 寡妇制造者",
    "n59003_a04":"兽王 寡妇制造者",
    "n59003_a05":"兽王 寡妇制造者",
    "n59003_B01":"大野猪",
    "n59003_B02":"大野猪",
    "n59003_B03":"大野猪",
    "n59003_B04":"大野猪",
    "n59003_B05":"大野猪",
    "n59003_B06":"大野猪",
    "n59003_B07":"大野猪",
    "n59003_B08":"大野猪",
    "n59003_B09":"大野猪",
    "n59003_B10":"大野猪",
    "n59003_B11":"大野猪",
    "n59003_B12":"大野猪",
    "n59003_B13":"大野猪",
    "n59003_B14":"大野猪",
    "n59003_B15":"大野猪",
    "n59003_B16":"大野猪",
    "n59003_B17":"大野猪",
    "n59003_B18":"大野猪",
    "n59003_B19":"大野猪",
    "n59003_B20":"大野猪",
    "n59003_B21":"大野猪",
    "n59003_B22":"大野猪",
    "n59003_B23":"大野猪",
    "n59003_B24":"大野猪",
    "n59003_B25":"大野猪",
    "n59003_B26":"大野猪",
    "n59003_B27":"大野猪",
    "n59003_B28":"大野猪",
    "n59003_B29":"大野猪",
    "n59003_B30":"大野猪",
    "n59003_B31":"大野猪",
    "n59003_B32":"大野猪",
    "n59003_B33":"大野猪",
    "n59003_B34":"大野猪",
    "n59003_B35":"大野猪",
    "n59003_B36":"大野猪",
    "n59003_B37":"大野猪",
    "n59003_B38":"大野猪",
    "n59003_B39":"大野猪",
    "n59003_B40":"大野猪",
    "n59003_B41":"大野猪",
    "n59003_B42":"大野猪",
    "n59003_B43":"大野猪",
    "n59003_B44":"大野猪",
    "n59003_B45":"大野猪",
    "n59003_B46":"大野猪",
    "n59003_B47":"大野猪",
    "n59003_B48":"大野猪",
    "n59003_B49":"大野猪",
    "n59003_B50":"大野猪",
    "n59003b":"大黑猪",
    "n59003c":"大黑猪",
    "n59003d":"大黑猪",
    "n59003e":"大黑猪",
    "n59004":"兽王 铁斧",
    "n59004_001":"野熊",
    "n59004_002":"野熊",
    "n59004_003":"野熊",
    "n59004_004":"野熊",
    "n59004_005":"野熊",
    "n59004_006":"野熊",
    "n59004_007":"野熊",
    "n59004_008":"野熊",
    "n59004_009":"野熊",
    "n59004_010":"野熊",
    "n59004_011":"野熊",
    "n59004_012":"野熊",
    "n59004_013":"野熊",
    "n59004_014":"野熊",
    "n59004_015":"野熊",
    "n59004_016":"野熊",
    "n59004_017":"野熊",
    "n59004_018":"野熊",
    "n59004_019":"野熊",
    "n59004_020":"野熊",
    "n59004_021":"野熊",
    "n59004_022":"野熊",
    "n59004_023":"野熊",
    "n59004_024":"野熊",
    "n59004_025":"野熊",
    "n59004_026":"野熊",
    "n59004_027":"野熊",
    "n59004_028":"野熊",
    "n59004_029":"野熊",
    "n59004_030":"野熊",
    "n59004_031":"野熊",
    "n59004_032":"野熊",
    "n59004_033":"野熊",
    "n59004_034":"野熊",
    "n59004_035":"野熊",
    "n59004_036":"野熊",
    "n59004_037":"野熊",
    "n59004_038":"野熊",
    "n59004_039":"野熊",
    "n59004_040":"野熊",
    "n59004_041":"野熊",
    "n59004_042":"野熊",
    "n59004_043":"野熊",
    "n59004_044":"野熊",
    "n59004_045":"野熊",
    "n59004_046":"野熊",
    "n59004_047":"野熊",
    "n59004_048":"野熊",
    "n59004_049":"野熊",
    "n59004_050":"野熊",
    "n59004_051":"野熊",
    "n59004_052":"野熊",
    "n59004_053":"野熊",
    "n59004_054":"野熊",
    "n59004_055":"野熊",
    "n59004_056":"野熊",
    "n59004_057":"野熊",
    "n59004_058":"野熊",
    "n59004_059":"野熊",
    "n59004_060":"野熊",
    "n59004_061":"野熊",
    "n59004_062":"野熊",
    "n59004_063":"野熊",
    "n59004_064":"野熊",
    "n59004_065":"野熊",
    "n59004_066":"野熊",
    "n59004_067":"野熊",
    "n59004_068":"野熊",
    "n59004_069":"野熊",
    "n59004_070":"野熊",
    "n59004_071":"野熊",
    "n59004_072":"野熊",
    "n59004_073":"野熊",
    "n59004_074":"野熊",
    "n59004_075":"野熊",
    "n59004_076":"野熊",
    "n59004_077":"野熊",
    "n59004_078":"野熊",
    "n59004_079":"野熊",
    "n59004_080":"野熊",
    "n59004_081":"野熊",
    "n59004_082":"野熊",
    "n59004_083":"野熊",
    "n59004_084":"野熊",
    "n59004_085":"野熊",
    "n59004_086":"野熊",
    "n59004_087":"野熊",
    "n59004_088":"野熊",
    "n59004_089":"野熊",
    "n59004_090":"野熊",
    "n59004_091":"野熊",
    "n59004_092":"野熊",
    "n59004_093":"野熊",
    "n59004_094":"野熊",
    "n59004_095":"野熊",
    "n59004_096":"野熊",
    "n59004_097":"野熊",
    "n59004_098":"野熊",
    "n59004_099":"野熊",
    "n59004_100":"野熊",
    "n59004_a01":"兽王 铁斧",
    "n59004_a02":"兽王 铁斧",
    "n59004_a03":"兽王 铁斧",
    "n59004_a04":"兽王 铁斧",
    "n59004_a05":"兽王 铁斧",
    "n59004b":"黑熊",
    "n59004c":"黑熊",
    "n59004d":"黑熊",
    "n59004e":"黑熊",
    "n59004f":"兽王 银掌",
    "n59004f_a01":"兽王 银掌",
    "n59004f_a02":"兽王 银掌",
    "n59004f_a03":"兽王 银掌",
    "n59004f_a04":"兽王 银掌",
    "n59004f_a05":"兽王 银掌",
    "n59004g":"白熊",
    "n59004h":"白熊",
    "n59004i":"白熊",
    "n59004j":"白熊",
    "n59005":"兽王 南霸天",
    "n59005_001":"野虎",
    "n59005_002":"野虎",
    "n59005_003":"野虎",
    "n59005_004":"野虎",
    "n59005_005":"野虎",
    "n59005_006":"野虎",
    "n59005_007":"野虎",
    "n59005_008":"野虎",
    "n59005_009":"野虎",
    "n59005_010":"野虎",
    "n59005_011":"野虎",
    "n59005_012":"野虎",
    "n59005_013":"野虎",
    "n59005_014":"野虎",
    "n59005_015":"野虎",
    "n59005_016":"野虎",
    "n59005_017":"野虎",
    "n59005_018":"野虎",
    "n59005_019":"野虎",
    "n59005_020":"野虎",
    "n59005_021":"野虎",
    "n59005_022":"野虎",
    "n59005_023":"野虎",
    "n59005_024":"野虎",
    "n59005_025":"野虎",
    "n59005_026":"野虎",
    "n59005_027":"野虎",
    "n59005_028":"野虎",
    "n59005_029":"野虎",
    "n59005_030":"野虎",
    "n59005_031":"野虎",
    "n59005_032":"野虎",
    "n59005_033":"野虎",
    "n59005_034":"野虎",
    "n59005_035":"野虎",
    "n59005_036":"野虎",
    "n59005_037":"野虎",
    "n59005_038":"野虎",
    "n59005_039":"野虎",
    "n59005_040":"野虎",
    "n59005_041":"野虎",
    "n59005_042":"野虎",
    "n59005_043":"野虎",
    "n59005_044":"野虎",
    "n59005_045":"野虎",
    "n59005_046":"野虎",
    "n59005_047":"野虎",
    "n59005_048":"野虎",
    "n59005_049":"野虎",
    "n59005_050":"野虎",
    "n59005_051":"野虎",
    "n59005_052":"野虎",
    "n59005_053":"野虎",
    "n59005_054":"野虎",
    "n59005_055":"野虎",
    "n59005_056":"野虎",
    "n59005_057":"野虎",
    "n59005_058":"野虎",
    "n59005_059":"野虎",
    "n59005_060":"野虎",
    "n59005_061":"野虎",
    "n59005_062":"野虎",
    "n59005_063":"野虎",
    "n59005_064":"野虎",
    "n59005_065":"野虎",
    "n59005_066":"野虎",
    "n59005_067":"野虎",
    "n59005_068":"野虎",
    "n59005_069":"野虎",
    "n59005_070":"野虎",
    "n59005_071":"野虎",
    "n59005_072":"野虎",
    "n59005_073":"野虎",
    "n59005_074":"野虎",
    "n59005_075":"野虎",
    "n59005_076":"野虎",
    "n59005_077":"野虎",
    "n59005_078":"野虎",
    "n59005_079":"野虎",
    "n59005_080":"野虎",
    "n59005_081":"野虎",
    "n59005_082":"野虎",
    "n59005_083":"野虎",
    "n59005_084":"野虎",
    "n59005_085":"野虎",
    "n59005_086":"野虎",
    "n59005_087":"野虎",
    "n59005_088":"野虎",
    "n59005_089":"野虎",
    "n59005_090":"野虎",
    "n59005_091":"野虎",
    "n59005_092":"野虎",
    "n59005_093":"野虎",
    "n59005_094":"野虎",
    "n59005_095":"野虎",
    "n59005_096":"野虎",
    "n59005_097":"野虎",
    "n59005_098":"野虎",
    "n59005_099":"野虎",
    "n59005_100":"野虎",
    "n59005_a01":"兽王 南霸天",
    "n59005_a02":"兽王 南霸天",
    "n59005_a03":"兽王 南霸天",
    "n59005_a04":"兽王 南霸天",
    "n59005_a05":"兽王 南霸天",
    "n59005b":"白虎",
    "n59005c":"白虎",
    "n59005d":"白虎",
    "n59005e":"白虎",
    "n59005f":"兽王 黑骨",
    "n59005f_a01":"兽王 黑骨",
    "n59005f_a02":"兽王 黑骨",
    "n59005f_a03":"兽王 黑骨",
    "n59005f_a04":"兽王 黑骨",
    "n59005f_a05":"兽王 黑骨",
    "n59005g":"黑蓝虎",
    "n59005h":"黑蓝虎",
    "n59006":"兽王 啼不住",
    "n59006_001":"大野猴",
    "n59006_002":"野猴",
    "n59006_003":"野猴",
    "n59006_004":"野猴",
    "n59006_011":"大野猴",
    "n59006_012":"野猴",
    "n59006_013":"野猴",
    "n59006_014":"野猴",
    "n59006_015":"野猴",
    "n59006_021":"大野猴",
    "n59006_022":"野猴",
    "n59006_023":"野猴",
    "n59006_031":"大野猴",
    "n59006_032":"野猴",
    "n59006_033":"野猴",
    "n59006_034":"野猴",
    "n59006_041":"大野猴",
    "n59006_042":"野猴",
    "n59006_043":"野猴",
    "n59006_044":"野猴",
    "n59006_045":"野猴",
    "n59006_051":"大野猴",
    "n59006_052":"野猴",
    "n59006_053":"野猴",
    "n59006_061":"大野猴",
    "n59006_062":"野猴",
    "n59006_063":"野猴",
    "n59006_064":"野猴",
    "n59006_071":"大野猴",
    "n59006_072":"野猴",
    "n59006_a01":"兽王 啼不住",
    "n59006_a02":"兽王 啼不住",
    "n59006_a03":"兽王 啼不住",
    "n59006_a04":"兽王 啼不住",
    "n59006_a05":"兽王 啼不住",
    "n59006b":"金丝猴",
    "n59006c":"金丝猴",
    "n59006d":"金丝猴",
    "n59006e":"金丝猴",
    "n59007_B01":"兽王 夜影",
    "n59007_B01a":"兽王 夜影",
    "n59007_B01b":"兽王 夜影",
    "n59007_B01c":"兽王 夜影",
    "n59007_B01d":"兽王 夜影",
    "n59007_B01e":"兽王 夜影",
    "n59007_B02":"黑豹",
    "n59007_B03":"黑豹",
    "n59007_B04":"黑豹",
    "n59007_B05":"黑豹",
    "n59007_W01":"兽王 雪影",
    "n59007_W01a":"兽王 雪影",
    "n59007_W01b":"兽王 雪影",
    "n59007_W01c":"兽王 雪影",
    "n59007_W01d":"兽王 雪影",
    "n59007_W01e":"兽王 雪影",
    "n59007_W02":"雪豹",
    "n59007_W03":"雪豹",
    "n59007_W04":"雪豹",
    "n59007_W05":"雪豹",
    "n59007_Y01":"花豹",
    "n59007_Y02":"花豹",
    "n59007_Y03":"花豹",
    "n59007_Y04":"花豹",
    "n59007_Y05":"花豹",
    "n59007_Y06":"花豹",
    "n59007_Y07":"花豹",
    "n59007_Y08":"花豹",
    "n59007_Y09":"花豹",
    "n59007_Y10":"花豹",
    "n59007_Y100":"花豹",
    "n59007_Y11":"花豹",
    "n59007_Y12":"花豹",
    "n59007_Y13":"花豹",
    "n59007_Y15":"花豹",
    "n59007_Y16":"花豹",
    "n59007_Y17":"花豹",
    "n59007_Y18":"花豹",
    "n59007_Y19":"花豹",
    "n59007_Y20":"花豹",
    "n59007_Y21":"花豹",
    "n59007_Y22":"花豹",
    "n59007_Y23":"花豹",
    "n59007_Y24":"花豹",
    "n59007_Y25":"花豹",
    "n59007_Y26":"花豹",
    "n59007_Y27":"花豹",
    "n59007_Y28":"花豹",
    "n59007_Y29":"花豹",
    "n59007_Y30":"花豹",
    "n59007_Y31":"花豹",
    "n59007_Y32":"花豹",
    "n59007_Y33":"花豹",
    "n59007_Y34":"花豹",
    "n59007_Y35":"花豹",
    "n59007_Y36":"花豹",
    "n59007_Y37":"花豹",
    "n59007_Y38":"花豹",
    "n59007_Y39":"花豹",
    "n59007_Y40":"花豹",
    "n59007_Y41":"花豹",
    "n59007_Y42":"花豹",
    "n59007_Y43":"花豹",
    "n59007_Y44":"花豹",
    "n59007_Y45":"花豹",
    "n59007_Y46":"花豹",
    "n59007_Y47":"花豹",
    "n59007_Y48":"花豹",
    "n59007_Y49":"花豹",
    "n59007_Y50":"花豹",
    "n59007_Y51":"花豹",
    "n59007_Y52":"花豹",
    "n59007_Y53":"花豹",
    "n59007_Y54":"花豹",
    "n59007_Y55":"花豹",
    "n59007_Y56":"花豹",
    "n59007_Y57":"花豹",
    "n59007_Y58":"花豹",
    "n59007_Y59":"花豹",
    "n59007_Y60":"花豹",
    "n59007_Y61":"花豹",
    "n59007_Y62":"花豹",
    "n59007_Y63":"花豹",
    "n59007_Y64":"花豹",
    "n59007_Y65":"花豹",
    "n59007_Y66":"花豹",
    "n59007_Y67":"花豹",
    "n59007_Y68":"花豹",
    "n59007_Y69":"花豹",
    "n59007_Y70":"花豹",
    "n59007_Y71":"花豹",
    "n59007_Y72":"花豹",
    "n59007_Y73":"花豹",
    "n59007_Y74":"花豹",
    "n59007_Y75":"花豹",
    "n59007_Y76":"花豹",
    "n59007_Y77":"花豹",
    "n59007_Y78":"花豹",
    "n59007_Y79":"花豹",
    "n59007_Y80":"花豹",
    "n59007_Y81":"花豹",
    "n59007_Y82":"花豹",
    "n59007_Y83":"花豹",
    "n59007_Y84":"花豹",
    "n59007_Y85":"花豹",
    "n59007_Y86":"花豹",
    "n59007_Y87":"花豹",
    "n59007_Y88":"花豹",
    "n59007_Y89":"花豹",
    "n59007_Y90":"花豹",
    "n59007_Y91":"花豹",
    "n59007_Y92":"花豹",
    "n59007_Y93":"花豹",
    "n59007_Y94":"花豹",
    "n59007_Y95":"花豹",
    "n59007_Y96":"花豹",
    "n59007_Y97":"花豹",
    "n59007_Y98":"花豹",
    "n59007_Y99":"花豹",
    "n59008":"兽王 巨木",
    "n59008_001":"兽王 巨木",
    "n59008_002":"兽王 巨木",
    "n59008_003":"兽王 巨木",
    "n59008_004":"兽王 巨木",
    "n59008_005":"兽王 巨木",
    "n59008_a01":"蟒蛇",
    "n59008_a02":"蟒蛇",
    "n59008_a03":"蟒蛇",
    "n59008_a04":"蟒蛇",
    "n59008_a05":"蟒蛇",
    "n59008_a06":"蟒蛇",
    "n59008_a07":"蟒蛇",
    "n59008_a08":"蟒蛇",
    "n59008_a09":"蟒蛇",
    "n59008_a10":"蟒蛇",
    "n59008_a11":"蟒蛇",
    "n59008_a12":"蟒蛇",
    "n59008_a13":"蟒蛇",
    "n59008_a14":"蟒蛇",
    "n59008_a15":"蟒蛇",
    "n59008_a16":"蟒蛇",
    "n59008_a17":"蟒蛇",
    "n59008_a18":"蟒蛇",
    "n59008_a19":"蟒蛇",
    "n59008_a20":"蟒蛇",
    "n59008_a21":"蟒蛇",
    "n59008_a22":"蟒蛇",
    "n59008_a23":"蟒蛇",
    "n59008_a24":"蟒蛇",
    "n59008_a25":"蟒蛇",
    "n59008_a26":"蟒蛇",
    "n59008_a27":"蟒蛇",
    "n59008_a28":"蟒蛇",
    "n59008_a29":"蟒蛇",
    "n59008_a30":"蟒蛇",
    "n59008_a31":"蟒蛇",
    "n59008_a32":"蟒蛇",
    "n59008_a33":"蟒蛇",
    "n59008_a34":"蟒蛇",
    "n59008_a35":"蟒蛇",
    "n59008_a36":"蟒蛇",
    "n59008_a37":"蟒蛇",
    "n59008_a38":"蟒蛇",
    "n59008_a39":"蟒蛇",
    "n59008_a40":"蟒蛇",
    "n59008_a41":"蟒蛇",
    "n59008_a42":"蟒蛇",
    "n59008_a43":"蟒蛇",
    "n59008_a44":"蟒蛇",
    "n59008_a45":"蟒蛇",
    "n59008_a46":"蟒蛇",
    "n59008_a47":"蟒蛇",
    "n59008_a48":"蟒蛇",
    "n59008_a49":"蟒蛇",
    "n59008_a50":"蟒蛇",
    "n59008_b01":"赤鳞毒蛇",
    "n59008_b02":"赤鳞毒蛇",
    "n59008_b03":"赤鳞毒蛇",
    "n59008_b04":"赤鳞毒蛇",
    "n59008_b05":"赤鳞毒蛇",
    "n59008_b06":"赤鳞毒蛇",
    "n59008_b08":"赤鳞毒蛇",
    "n59008_b09":"赤鳞毒蛇",
    "n59008_b10":"赤鳞毒蛇",
    "n59008_b11":"赤鳞毒蛇",
    "n59008_b12":"赤鳞毒蛇",
    "n59008_b13":"赤鳞毒蛇",
    "n59008_b14":"赤鳞毒蛇",
    "n59008_b15":"赤鳞毒蛇",
    "n59008_b16":"赤鳞毒蛇",
    "n59008_b17":"赤鳞毒蛇",
    "n59008_b18":"赤鳞毒蛇",
    "n59008_b19":"赤鳞毒蛇",
    "n59008_b20":"赤鳞毒蛇",
    "n59008_b21":"赤鳞毒蛇",
    "n59008_b22":"赤鳞毒蛇",
    "n59008_b23":"赤鳞毒蛇",
    "n59008_b24":"赤鳞毒蛇",
    "n59008_b25":"赤鳞毒蛇",
    "n59008_b26":"赤鳞毒蛇",
    "n59008_b27":"赤鳞毒蛇",
    "n59008_b28":"赤鳞毒蛇",
    "n59008_b29":"赤鳞毒蛇",
    "n59008_b30":"赤鳞毒蛇",
    "n59008_b31":"赤鳞毒蛇",
    "n59008_b32":"赤鳞毒蛇",
    "n59008_b33":"赤鳞毒蛇",
    "n59008_b34":"赤鳞毒蛇",
    "n59008_b35":"赤鳞毒蛇",
    "n59008_b36":"赤鳞毒蛇",
    "n59008_b37":"赤鳞毒蛇",
    "n59008_b38":"赤鳞毒蛇",
    "n59008_b39":"赤鳞毒蛇",
    "n59008_b40":"赤鳞毒蛇",
    "n59008_b41":"赤鳞毒蛇",
    "n59008_b42":"赤鳞毒蛇",
    "n59008_b43":"赤鳞毒蛇",
    "n59008_b44":"赤鳞毒蛇",
    "n59008_b45":"赤鳞毒蛇",
    "n59008_b46":"赤鳞毒蛇",
    "n59008_b47":"赤鳞毒蛇",
    "n59008_b48":"赤鳞毒蛇",
    "n59008_b49":"赤鳞毒蛇",
    "n59008_b50":"赤鳞毒蛇",
    "n59008_c01":"青鳞毒蛇",
    "n59008_c02":"青鳞毒蛇",
    "n59008_c03":"青鳞毒蛇",
    "n59008_c04":"青鳞毒蛇",
    "n59008_c05":"青鳞毒蛇",
    "n59008_c06":"青鳞毒蛇",
    "n59008_c07":"青鳞毒蛇",
    "n59008_c08":"青鳞毒蛇",
    "n59008_c09":"青鳞毒蛇",
    "n59008_c10":"青鳞毒蛇",
    "n59008_c11":"青鳞毒蛇",
    "n59008_c12":"青鳞毒蛇",
    "n59008_c13":"青鳞毒蛇",
    "n59008_c14":"青鳞毒蛇",
    "n59008_c15":"青鳞毒蛇",
    "n59008_c16":"青鳞毒蛇",
    "n59008_c17":"青鳞毒蛇",
    "n59008_c18":"青鳞毒蛇",
    "n59008_c19":"青鳞毒蛇",
    "n59008_c20":"青鳞毒蛇",
    "n59008_c21":"青鳞毒蛇",
    "n59008_c22":"青鳞毒蛇",
    "n59008_c23":"青鳞毒蛇",
    "n59008_c24":"青鳞毒蛇",
    "n59008_c25":"青鳞毒蛇",
    "n59008_c26":"青鳞毒蛇",
    "n59008_c27":"青鳞毒蛇",
    "n59008_c28":"青鳞毒蛇",
    "n59008_c29":"青鳞毒蛇",
    "n59008_c30":"青鳞毒蛇",
    "n59008_c31":"青鳞毒蛇",
    "n59008_c32":"青鳞毒蛇",
    "n59008_c33":"青鳞毒蛇",
    "n59008_c34":"青鳞毒蛇",
    "n59008_c35":"青鳞毒蛇",
    "n59008_c36":"青鳞毒蛇",
    "n59008_c37":"青鳞毒蛇",
    "n59008_c38":"青鳞毒蛇",
    "n59008_c39":"青鳞毒蛇",
    "n59008_c40":"青鳞毒蛇",
    "n59008_c41":"青鳞毒蛇",
    "n59008_c42":"青鳞毒蛇",
    "n59008_c43":"青鳞毒蛇",
    "n59008_c44":"青鳞毒蛇",
    "n59008_c45":"青鳞毒蛇",
    "n59008_c46":"青鳞毒蛇",
    "n59008_c47":"青鳞毒蛇",
    "n59008_c48":"青鳞毒蛇",
    "n59008_c49":"青鳞毒蛇",
    "n59008_c50":"青鳞毒蛇",
    "n59008b":"菩斯曲蛇",
    "n59008c":"菩斯曲蛇",
    "n59008d":"菩斯曲蛇",
    "n59008e":"菩斯曲蛇",
    "n59009":"兽王 金鬃",
    "n59009_a01":"兽王 金鬃",
    "n59009_a02":"兽王 金鬃",
    "n59009_a03":"兽王 金鬃",
    "n59009_a04":"兽王 金鬃",
    "n59009_a05":"兽王 金鬃",
    "n59995":"接兔秘籍商人",
    "n60001":"淘石帮 周益",
    "n60002":"淘石帮 陶大石",
    "n60003":"淘石帮 光头天",
    "n60003b":"淘石帮 光头天",
    "n60004":"西门玉堂",
    "n60004a":"西门玉堂",
    "n60004b":"西门玉堂",
    "n60004c":"西门玉堂",
    "n60006":"叶大威",
    "n60007":"东郭强",
    "n60008":"淘石帮 郝孝",
    "n60009":"陶文才",
    "n60012":"淘石帮 封俊文",
    "n60013":"淘石帮 封俊智",
    "n60014":"钱大富",
    "n60015":"王有财",
    "n60016":"护院 古意",
    "n60019":"桃花妹",
    "n60020":"杜昌",
    "n60021":"孙洽",
    "n60022":"伍高",
    "n60024":"商人 向宏",
    "n60024b":"商人 向宏",
    "n60025":"伙食工 孙大娘",
    "n60026":"杂工 惠勇",
    "n60028":"万海峰",
    "n60029":"姜寒",
    "n60031":"包材义",
    "n60032":"田俊",
    "n60035":"晏维",
    "n60041":"柏俊才",
    "n60042":"流云坊 巴慕云",
    "n60043":"流云坊掌柜 巴宏大",
    "n60055":"鄂斯伯",
    "n60060":"婢女 怜儿",
    "n60061":"婢女 惜儿",
    "n60066":"苏清瑞",
    "n60067":"景府管家 景焕",
    "n60068":"景泰然",
    "n60069":"董春莲",
    "n60073":"春宝",
    "n60074":"夏宝",
    "n60078":"白马居 蔺之嘉",
    "n60089a":"鳄鱼",
    "n60089b":"鳄鱼",
    "n60089c":"鳄鱼",
    "n60089d":"鳄鱼",
    "n60089e":"鳄鱼",
    "n60089f":"鳄鱼",
    "n60094":"俏梦阁老鸨 彩姨",
    "n60106":"容艳雪",
    "n60109":"打手 牌九",
    "n60110":"打手 马吊",
    "n60111":"打手 骰子哥",
    "n60112":"何老头",
    "n60113":"郭猎户",
    "n60114":"袁猎户",
    "n60116":"郭婶子",
    "n60117":"打手 同花顺",
    "n60118":"打手 买大",
    "n60119":"打手 买小",
    "n60120":"打手 向宫",
    "n60121":"伤人恶虎",
    "n60121b":"伤人恶虎",
    "n60121c":"伤人恶虎",
    "n60121d":"伤人恶虎",
    "n60127":"琴儿",
    "n60132":"夏柳",
    "n60147":"虚弱的黄鳞毒蛇",
    "n60148":"虚弱的赤练蛇",
    "n60149":"虚弱的青蛇",
    "n60150":"黄鳞毒蛇",
    "n60151":"赤练蛇",
    "n60152":"青蛇",
    "n60156":"樵夫 陆大斧",
    "n60158":"老板 马五花",
    "n60159":"金丝灵猴",
    "n60160":"金丝灵猴",
    "n60161":"金丝灵猴",
    "n60162":"金丝灵猴",
    "n60163":"金丝灵猴",
    "n60164":"常粉",
    "n60166":"米店老板娘",
    "n60167":"杂货店老板",
    "n60173":"韩公子",
    "n60174":"卢公子",
    "n60178":"黑衣人 左",
    "n60179":"黑衣人 右",
    "n60180":"黑衣人 甲",
    "n60181":"黑衣人 乙",
    "n60183":"黑衣人 丙",
    "n60184":"骚人",
    "n60185":"墨客",
    "n60186-1":"缺心眼",
    "n60186-2":"毛道人",
    "n60186-3":"周不胖",
    "n60186-4":"赖皮王",
    "n60186-5":"文默",
    "n60186-6":"快腿张",
    "n60187":"矿坑守卫 童大锤",
    "n60189a":"矿坑守卫",
    "n60189b":"矿坑守卫",
    "n60189c":"矿坑守卫",
    "n60189d":"矿坑守卫",
    "n60189e":"矿坑守卫",
    "n60189f":"矿坑守卫",
    "n60189g":"矿坑守卫",
    "n60189h":"矿坑守卫",
    "n60189i":"矿坑守卫",
    "n60190b":"矿工 勾远",
    "n60190c":"矿工 屈大雅",
    "n60192a":"淘石帮众",
    "n60192b":"淘石帮众",
    "n60192c":"淘石帮众",
    "n60193a":"淘石帮 憨豆",
    "n60193b":"淘石帮 驴蛋",
    "n60194":"俏梦阁老鸨 宝姨",
    "n60201":"毛大瑞",
    "n60202":"梅信辉",
    "n60203":"掌柜 吉大发",
    "n60204":"梅铸方",
    "n60205":"束阿桂",
    "n60206":"田大妈",
    "n60207":"杂货铺 杨柳",
    "n60208":"梅福齐",
    "n60209":"酒庄弟子 龚元魁",
    "n60210":"农夫 王春",
    "n60214":"梅天雄",
    "n60215":"阿猫",
    "n60216":"阿狗",
    "n60217":"小金鱼",
    "n60218":"猴子",
    "n60221":"蛮力野猪",
    "n60222":"刀疤野猪",
    "n60223":"咆哮野猪",
    "n60224":"野猪",
    "n60225":"野猪",
    "n60226":"野猪",
    "n60227":"哑巴小孩",
    "n60228":"漏网之猪",
    "n60229":"农妇　车大娘",
    "n60230":"梅红绮",
    "n60233":"齐叔",
    "n60234":"黄大嫂",
    "n60235":"陈妈",
    "n60236":"乡勇 臭头张",
    "n60238":"乡勇 王阿八",
    "n60239":"乡勇 邱大虫",
    "n60245":"盗书贼",
    "n60246":"钟离经略",
    "n60247":"乡勇 马驷发",
    "n60248":"乡勇 马参发",
    "n60249":"乡勇 马并发",
    "n60250":"乡勇 马大发",
    "n60252":"流寇 缺牙儿",
    "n60253":"流寇 烂腿子",
    "n60254":"流寇 癞痢王",
    "n60255":"乡勇 曾有为",
    "n60256":"乡勇 曹上进",
    "n60257":"乡勇 溥给力",
    "n60258a":"野猪",
    "n60258ab":"野猪",
    "n60258ac":"野猪",
    "n60258ad":"野猪",
    "n60258b":"野猪",
    "n60258bb":"野猪",
    "n60258bc":"野猪",
    "n60258c":"野猪",
    "n60258cb":"野猪",
    "n60258d":"野猪",
    "n60258e":"野猪",
    "n60258eb":"野猪",
    "n60258ec":"野猪",
    "n60258f":"野猪",
    "n60258fb":"野猪",
    "n60258g":"野猪",
    "n60258gb":"野猪",
    "n60258h":"野猪",
    "n60258hb":"野猪",
    "n60258hc":"野猪",
    "n60258hd":"野猪",
    "n60258he":"野猪",
    "n60258i":"野猪",
    "n60258ib":"野猪",
    "n60258ic":"野猪",
    "n60262":"大红花",
    "n60263":"采药大娘",
    "n60271":"小七",
    "n60272":"小阿未",
    "n60274":"黑皮",
    "n60276":"蒋留若",
    "n60278":"野熊",
    "n60279":"流寇",
    "n60280":"流寇",
    "n60301":"三郎 陈志淇",
    "n60302":"大郎 陈志泽",
    "n60303":"二郎 陈志潾",
    "n60304":"庄主 陈长卫",
    "n60305":"老太爷 陈昊天",
    "n60306":"嫡系 陈琰",
    "n60307":"嫡系 陈环",
    "n60308":"旁系 陈境",
    "n60309":"旁系 陈埈",
    "n60310":"旁系 陈地",
    "n60311":"旁系 陈坡",
    "n60312":"旁系 陈坪",
    "n60313":"旁系 陈址",
    "n60314":"旁系 陈坊",
    "n60315":"嫡系 陈琨",
    "n60316":"嫡系 陈琼",
    "n60317":"嫡系 陈顼",
    "n60318":"嫡系 陈珠",
    "n60319":"旁系 陈坷",
    "n60337":"嫡系 陈璞",
    "n60338":"嫡系 陈瑞",
    "n60339":"嫡系 陈璩",
    "n60341a":"锦衣卫",
    "n60341b":"锦衣卫",
    "n60341c":"锦衣卫",
    "n60341d":"锦衣卫",
    "n60341e":"锦衣卫",
    "n60341f":"锦衣卫",
    "n60341g":"锦衣卫",
    "n60341h":"锦衣卫",
    "n60341i":"锦衣卫",
    "n60342":"锦衣卫队长",
    "n60347":"菩斯曲蛇",
    "n60348a":"蟒蛇",
    "n60348b":"蟒蛇",
    "n60348c":"蟒蛇",
    "n60349a":"赤鳞毒蛇",
    "n60349b":"赤鳞毒蛇",
    "n60349c":"赤鳞毒蛇",
    "n60349d":"青鳞毒蛇",
    "n60349e":"青鳞毒蛇",
    "n60401":"陈之济",
    "n60401c":"陈之济",
    "n60403":"杜玉绯",
    "n60403c":"杜玉绯",
    "n60409":"棕熊",
    "n60410":"黑熊",
    "n60411":"黑熊",
    "n60412":"商人 梧良",
    "n60413":"南巫",
    "n60414":"鼻涕小张张",
    "n60415":"王琦年",
    "n60416":"韩老爹",
    "n60417":"小阿英",
    "n60418a":"衙役",
    "n60418b":"衙役",
    "n60418c":"衙役",
    "n60419a":"盗匪",
    "n60419b":"盗匪",
    "n60419c":"盗匪",
    "n60425a":"毒殭",
    "n60425b":"毒殭",
    "n60425c":"毒殭",
    "n60426a":"毒殭",
    "n60426b":"毒殭",
    "n60426c":"毒殭",
    "n60426d":"毒殭",
    "n60426e":"毒殭",
    "n60426f":"毒殭",
    "n60426g":"毒殭",
    "n60426h":"毒殭",
    "n60426i":"毒殭",
    "n60426j":"毒殭",
    "n60426k":"毒殭",
    "n60426l":"毒殭",
    "n60426m":"毒殭",
    "n60426n":"毒殭",
    "n60426o":"毒殭",
    "n60426p":"毒殭",
    "n60426q":"毒殭",
    "n60426r":"毒殭",
    "n60426s":"毒殭",
    "n60426t":"毒殭",
    "n60426u":"毒殭",
    "n60426v":"毒殭",
    "n60426w":"毒殭",
    "n60426x":"毒殭",
    "n60426y":"毒殭",
    "n60426z":"毒殭",
    "n60427":"樵夫 郭光",
    "n60430":"衙门左兵卫",
    "n60431":"衙门右兵卫",
    "n60435":"衙役",
    "n60437c":"桔糖",
    "n60437d":"虎爸",
    "n60437e":"虎妈",
    "n60441":"冯秋香",
    "n60444":"衙役",
    "n60448":"杜府 罗嬷嬷",
    "n60501":"玉轮长老",
    "n60502":"金蟾长老",
    "n60503":"蔻桂长老",
    "n60504":"灵兔长老",
    "n60505":"姮娥长老",
    "n60506":"太阴至尊",
    "n60513":"太华门 星辉",
    "n60514":"太华门 盈月",
    "n60515":"太华门 蚀月",
    "n60516":"太华门 弦月",
    "n60517":"太华门 妘左",
    "n60518":"太华门 妘右",
    "n60519":"太华门 姒武",
    "n60520":"太华门 姬纹",
    "n60521":"太华门 孔慕楚",
    "n60522":"太华门 秦尚礼",
    "n60523":"热炒大厨",
    "n60524":"火龙珠小贩",
    "n60525":"休息小二",
    "n60526":"丹药店老板",
    "n60527":"武器店老板",
    "n60538":"面摊老板",
    "n60539":"豆腐花小贩",
    "n60540":"寻珍阁 帮众",
    "n60541":"寻珍阁 帮众",
    "n60542":"寻珍阁 帮众",
    "n60543":"寻珍阁 帮众",
    "n60544":"流寇",
    "n60545":"流寇",
    "n60546":"流寇",
    "n60547":"流寇",
    "n60548":"流寇",
    "n60549":"流寇",
    "n60550":"流寇",
    "n60551":"流寇",
    "n60557":"棕熊",
    "n60558":"棕熊",
    "n60559":"棕熊",
    "n60561":"泼墨雪",
    "n60561b":"泼墨雪",
    "n60561c":"泼墨雪",
    "n60561d":"泼墨雪",
    "n60561e":"泼墨雪",
    "n60562":"公冶猛",
    "n60563":"公冶刚",
    "n60564":"公冶铁",
    "n60565":"船夫",
    "n60566":"茫丐",
    "n60570":"孙元",
    "n60577":"杂货郎",
    "n60578":"农夫 大川",
    "n60579":"农夫 阿菜叔",
    "n60580":"农夫 陆叔",
    "n60581":"农夫 游伯",
    "n60582":"农夫 郑大典",
    "n60583":"农夫 牛励",
    "n60584a":"大野猴",
    "n60584b":"野猴",
    "n60584c":"野猴",
    "n60584d":"野猴",
    "n60585a":"大野猴",
    "n60585b":"大野猴",
    "n60585c":"野猴",
    "n60585d":"大野猴",
    "n60586a":"野牛",
    "n60586b":"野牛",
    "n60586c":"野牛",
    "n60586d":"野牛",
    "n60588":"烧饼小贩",
    "n60589":"卖菜老板娘",
    "n60590":"鱼铺老板",
    "n60591":"食肆老板娘",
    "n60592":"调味料小贩",
    "n60593a":"流寇",
    "n60593b":"流寇",
    "n60593c":"流寇",
    "n60593d":"流寇",
    "n60593e":"流寇",
    "n60593f":"流寇",
    "n60593g":"流寇",
    "n60593h":"流寇",
    "n60593i":"流寇",
    "n60593j":"流寇",
    "n60593k":"流寇",
    "n60593l":"流寇",
    "n60600":"白鹤",
    "n60601":"花燕",
    "n60602":"花雀",
    "n60603-1":"铁喙",
    "n60603-2":"刁旋",
    "n60603-3":"实留",
    "n60603-4":"箭羽",
    "n69002":"梅谷立",
    "n70021":"鹰猎人守卫",
    "n70022":"鹰猎人守卫",
    "n70044":"凌中岳",
    "n70056":"郝信",
    "n70057":"令狐云",
    "n70058":"余三白",
    "n70059":"糜壬言",
    "n70060":"孟桐",
    "n70061":"迷魂水寨帮众",
    "n70062":"迷魂水寨帮众",
    "n70063":"迷魂水寨帮众",
    "n70064":"迷魂水寨帮众",
    "n70065":"迷魂水寨帮众",
    "n70066":"迷魂水寨帮众",
    "n70067":"迷魂水寨帮众",
    "n70068":"迷魂水寨帮众",
    "n70069":"迷魂水寨帮众",
    "n70070":"张烈海",
    "n80003":"拦路流寇",
    "n80004":"拦路流寇",
    "n80005":"拦路流寇",
    "n80006":"阿膳师",
    "n80007":"老樵夫",
    "n80008":"无口厨子",
    "n80009":"大研镇猎人",
    "n80010":"流寇首领",
    "n80011":"流寇爪牙",
    "n80014":"孔大娘",
    "n80015":"豹王寨厨子",
    "n80017":"巩竹",
    "n80018":"神秘女子",
    "n80101":"盗墓弟",
    "n80102":"盗墓哥",
    "n80021":"丘大龙",
    "n80022":"丘二龙",
    "n80023":"丘少龙",
    "n80026":"石为天",
    "n80027":"石为地",
    "n80028":"野猪",
    "n80028a":"野猪",
    "n80028b":"野猪",
    "n80028c":"野猪",
    "n80030a":"刁不易",
    "n80032":"野猴",
    "n80032a":"野猴",
    "n80032b":"野猴",
    "n80032c":"野猴",
    "n80032d":"野猴",
    "n80034":"柴夫",
    "n80036":"忧愁的男子",
    "n80037":"行路人",
    "n80038":"流浪厨子",
    "n80039":"老柴头",
    "n80040":"大青蛇",
    "n80041":"羊",
    "n80042":"羊",
    "n80044":"行脚商人",
    "n80045":"荒山钓客",
    "n80046":"文三娘",
    "n80046a":"文三娘",
    "n80047":"野猪",
    "n80048":"野猪",
    "n80049":"野猪",
    "n80050":"野猪",
    "n80051":"野猪",
    "n80052":"野猪",
    "n80053":"流寇",
    "n80054":"流寇",
    "n80055":"旅行菜贩",
    "n80056":"凉粉小贩",
    "n80057":"阿田",
    "n80058":"巴大哥",
    "n80059":"巴家家丁",
    "n80060":"巴家家丁",
    "n80061":"大喇嘛",
    "n80062":"喇嘛",
    "n80064":"小范",
    "n80065":"小谢",
    "n80066":"神秘男子",
    "n80067":"瞎眼老妇",
    "n80068":"骆原",
    "n80070":"商队商人",
    "n80071":"商队行脚商人",
    "n80072":"商队商人领队",
    "n80073":"商队商人",
    "n80074":"年轻商队商人",
    "n80077":"鲜于平",
    "n80078":"大内密探陆盛",
    "n80079":"古莫言",
    "n80080":"陌生盐商",
    "n80083":"隐世老翁",
    "n80085":"外乡客",
    "n80086":"柴义",
    "n80087":"樊景相",
    "n80088":"虎头三",
    "n80089":"徐宁波",
    "n80090":"闻苍海",
    "n80091":"祭拜妇人",
    "n80092":"纳西族男子",
    "n80093":"纳西族男子",
    "n80094":"纳西族妇人",
    "n80095":"纳西老者",
    "n80096":"纳西族青年",
    "n80097":"丁承澐",
    "n80098":"戚长风",
    "n80099":"花仲城",
    "n80100":"刘铁骨",
    "n80103":"小童",
    "n80104":"闲汉",
    "n80105":"醉汉",
    "n80106":"虎头三手下",
    "n80107":"虎头三手下",
    "n80108":"虎头三手下",
    "n80109":"虎头三手下",
    "n80110":"虎头三手下",
    "n80111":"菜园张",
    "n80111a":"菜园张",
    "n80112":"文三娘手下",
    "n80113":"文三娘手下",
    "n80114":"粗恶的壮汉",
    "n80115":"凶狠的壮汉",
    "n80116":"客栈伙计",
    "n80117":"客栈伙计",
    "n80118":"客栈伙计",
    "n80119":"金满腹",
    "n80121":"文三娘手下",
    "n80122":"文三娘手下",
    "n80123":"文三娘手下",
    "n80124":"文三娘手下",
    "n80125":"文三娘伙计",
    "n80126":"文三娘伙计",
    "n80127":"文三娘手下",
    "n80128":"文三娘手下",
    "n80129":"文三娘手下",
    "n80150":"奇怪的巨猿",
    "n80150a":"「巨猿之王」猴三",
    "n80150b":"「巨猿之王」猴三",
    "n80150c":"「巨猿之王」猴三",
    "n80150d":"「巨猿之王」猴三",
    "n80150e":"「巨猿之王」猴三",
    "n80152":"「醉药仙」孙东元",
    "n80155":"叶家马帮帮众",
    "n80156":"叶家马帮帮众",
    "n80157":"黑衣人",
    "n80158":"黑衣人",
    "n80159":"黑衣人",
    "n80160":"大研镇卫兵",
    "n80161":"肉店老板",
    "n80162":"毛皮店老板",
    "n80163":"擎天寨众",
    "n80164":"擎天寨众",
    "n80165":"擎天寨众",
    "n80166":"擎天寨众",
    "n80167":"擎天寨众",
    "n80168":"擎天寨众",
    "n80169":"擎天寨众",
    "n80170":"擎天寨众",
    "n80171":"擎天寨众",
    "n80172":"擎天寨众",
    "n80173":"擎天寨众",
    "n80174":"擎天寨众",
    "n80175":"擎天寨众",
    "n80176":"擎天寨众",
    "n80177":"金石谷军需官",
    "n80178":"蔘王山军需官",
    "n80179":"金石谷帮众",
    "n80180":"金石谷帮众",
    "n80181":"蔘王山帮众",
    "n80182":"蔘王山帮众",
    "n80183":"金石谷帮众",
    "n80184":"金石谷帮众",
    "n80185":"金石谷帮众",
    "n80186":"蔘王山帮众",
    "n80187":"蔘王山帮众",
    "n80188":"蔘王山帮众",
    "n80189":"金石谷帮众",
    "n80190":"金石谷帮众",
    "n80191":"金石谷帮众",
    "n80192":"金石谷帮众",
    "n80193":"金石谷帮众",
    "n80194":"金石谷帮众",
    "n80195":"金石谷帮众",
    "n80196":"金石谷帮众",
    "n80197":"金石谷帮众",
    "n80198":"金石谷帮众",
    "n80199":"金石谷帮众",
    "n80200":"金石谷帮众",
    "n80201":"金石谷帮众",
    "n80202":"金石谷帮众",
    "n80203":"金石谷帮众",
    "n80204":"金石谷帮众",
    "n80205":"金石谷帮众",
    "n80206":"金石谷帮众",
    "n80207":"金石谷帮众",
    "n80208":"金石谷帮众",
    "n80209":"金石谷帮众",
    "n80210":"金石谷帮众",
    "n80211":"金石谷帮众",
    "n80212":"金石谷帮众",
    "n80213":"金石谷帮众",
    "n80214":"金石谷帮众",
    "n80215":"金石谷帮众",
    "n80216":"金石谷帮众",
    "n80217":"金石谷帮众",
    "n80218":"金石谷帮众",
    "n80219":"金石谷帮众",
    "n80220":"金石谷帮众",
    "n80221":"金石谷帮众",
    "n80222":"金石谷帮众",
    "n80223":"金石谷帮众",
    "n80224":"金石谷帮众",
    "n80225":"金石谷帮众",
    "n80226":"金石谷帮众",
    "n80227":"金石谷帮众",
    "n80228":"金石谷帮众",
    "n80229":"金石谷帮众",
    "n80230":"金石谷帮众",
    "n80231":"金石谷帮众",
    "n80232":"金石谷帮众",
    "n80233":"金石谷帮众",
    "n80234":"金石谷帮众",
    "n80235":"金石谷帮众",
    "n80236":"金石谷帮众",
    "n80237":"金石谷帮众",
    "n80238":"金石谷帮众",
    "n80239":"金石谷帮众",
    "n80240":"金石谷首领",
    "n80241":"蔘王山帮众",
    "n80242":"蔘王山帮众",
    "n80243":"蔘王山帮众",
    "n80244":"蔘王山帮众",
    "n80245":"蔘王山帮众",
    "n80246":"蔘王山帮众",
    "n80247":"蔘王山帮众",
    "n80248":"蔘王山帮众",
    "n80249":"蔘王山帮众",
    "n80250":"蔘王山帮众",
    "n80251":"蔘王山帮众",
    "n80252":"蔘王山帮众",
    "n80253":"蔘王山帮众",
    "n80254":"蔘王山帮众",
    "n80255":"蔘王山帮众",
    "n80256":"蔘王山帮众",
    "n80257":"蔘王山帮众",
    "n80258":"蔘王山帮众",
    "n80259":"蔘王山帮众",
    "n80260":"蔘王山帮众",
    "n80261":"蔘王山帮众",
    "n80262":"蔘王山帮众",
    "n80263":"蔘王山帮众",
    "n80264":"蔘王山帮众",
    "n80265":"蔘王山帮众",
    "n80266":"蔘王山帮众",
    "n80267":"蔘王山帮众",
    "n80268":"蔘王山帮众",
    "n80269":"蔘王山帮众",
    "n80270":"蔘王山帮众",
    "n80271":"蔘王山帮众",
    "n80272":"蔘王山帮众",
    "n80273":"蔘王山帮众",
    "n80274":"蔘王山帮众",
    "n80275":"蔘王山帮众",
    "n80276":"蔘王山帮众",
    "n80277":"蔘王山帮众",
    "n80278":"蔘王山帮众",
    "n80279":"蔘王山帮众",
    "n80280":"蔘王山帮众",
    "n80281":"蔘王山帮众",
    "n80282":"蔘王山帮众",
    "n80283":"蔘王山帮众",
    "n80284":"蔘王山帮众",
    "n80285":"蔘王山帮众",
    "n80286":"蔘王山帮众",
    "n80287":"蔘王山帮众",
    "n80288":"蔘王山帮众",
    "n80289":"蔘王山帮众",
    "n80290":"蔘王山帮众",
    "n80291":"蔘王山帮众",
    "n80292":"蔘王山帮众",
    "n80293":"蔘王山帮众",
    "n80294":"蔘王山帮众",
    "n80295":"蔘王山帮众",
    "n80296":"蔘王山首领",
    "n80297":"受雇的工人",
    "n80298":"受雇的工人",
    "n80299":"受雇的工人",
    "n80300":"受雇的工人",
    "n80301":"受雇的工人",
    "n80302":"受雇的工人",
    "n80303":"受雇的工人",
    "n80304":"受雇的工人",
    "n80305":"受雇的工人",
    "n80306":"受雇的工人",
    "n80307":"受雇的工人",
    "n80308":"受雇的工人",
    "n80309":"受雇的工人",
    "n80310":"受雇的工人",
    "n80311":"受雇的工人",
    "n80377":"练无情",
    "n80378":"纪玫湘",
    "n80379":"百兽庄帮众",
    "n80380":"纪玫青",
    "n80381":"百兽庄帮众",
    "n80382":"百兽庄帮众",
    "n80383":"巨鲨帮帮众",
    "n80384":"巨鲨帮帮众",
    "n80385":"巨鲨帮帮众",
    "n80386":"蔘王山帮众",
    "n80387":"蔘王山帮众",
    "n80388":"蔘王山帮众",
    "n80389":"金石谷帮众",
    "n80390":"金石谷帮众",
    "n80391":"金石谷帮众",
    "n80392":"江湖人",
    "n80393":"江湖人",
    "n80394":"江湖人",
    "n80395":"江湖人",
    "n80396":"迷魂水寨帮众",
    "n80397":"迷魂水寨帮众",
    "n80398":"迷魂水寨帮众",
    "n80399":"迷魂水寨帮众",
    "n80400":"迷魂水寨帮众",
    "n80401":"迷魂水寨帮众",
    "n80402":"迷魂水寨帮众",
    "n80403":"迷魂水寨帮众",
    "n80404":"迷魂水寨帮众",
    "n80405":"江湖人",
    "n80406":"江湖人",
    "n80407":"江湖人",
    "n80408":"江湖人",
    "n80409":"迷魂水寨物资官",
    "n80410":"舒辉",
    "n80411":"舒伦",
    "n80412":"舒杀",
    "n80413":"福多",
    "n80414":"黎库",
    "n80428":"迷魂水寨帮众",
    "n80429":"迷魂水寨帮众",
    "n80430":"迷魂水寨帮众",
    "n80431":"迷魂水寨帮众",
    "n80432":"迷魂水寨帮众",
    "n80433":"迷魂水寨帮众",
    "n80434":"迷魂水寨帮众",
    "n80435":"迷魂水寨帮众",
    "n80436":"迷魂水寨帮众",
    "n80437":"迷魂水寨帮众",
    "n80438":"迷魂水寨帮众",
    "n80439":"迷魂水寨帮众",
    "n80440":"迷魂水寨帮众",
    "n80441":"迷魂水寨帮众",
    "n80442":"迷魂水寨帮众",
    "n80443":"迷魂水寨帮众",
    "n80444":"迷魂水寨帮众",
    "n80445":"迷魂水寨帮众",
    "n80446":"迷魂水寨帮众",
    "n80447":"迷魂水寨帮众",
    "n80448":"迷魂水寨帮众",
    "n80449":"湖贼",
    "n80450":"湖贼",
    "n80451":"湖贼",
    "n80452":"湖贼",
    "n80453":"湖贼",
    "n80454":"湖贼",
    "n80455":"湖贼",
    "n80456":"湖贼",
    "n80457":"湖贼",
    "n80458":"湖贼",
    "n80459":"湖贼",
    "n80460":"湖贼",
    "n80461":"湖贼",
    "n80462":"湖贼",
    "n80463":"湖贼",
    "n80464":"湖贼",
    "n80465":"湖贼",
    "n80466":"湖贼",
    "n80467":"湖贼",
    "n80468":"湖贼",
    "n80469":"湖贼",
    "n80470":"山贼",
    "n80471":"山贼",
    "n80472":"山贼",
    "n80473":"山贼",
    "n80474":"山贼",
    "n80475":"山贼",
    "n80476":"山贼",
    "n80477":"山贼",
    "n80478":"山贼",
    "n80479":"山贼",
    "n80480":"山贼王",
    "n80481":"包打听",
    "n80482":"道可畏",
    "n80483":"艾胡说",
    "n80484":"百晓生",
    "n80485":"包爱听",
    "n88887":"咘咘",
    "n88888":"绝世高手阿曼",
    "n88890":"刃屠灵",
    "n90001":"丈人村老太",
    "n90002":"丈人村老伯",
    "n90005":"工头 杨武",
    "n90006":"工头 辜洪禄",
    "n90007":"粗工 王德",
    "n90008":"粗工 张阿大",
    "n90009":"药铺伙计",
    "n90010":"粗工 吕扬",
    "n90012":"方如花",
    "n90013":"铁小轻",
    "n90014":"药铺老板",
    "n90015":"小丐阿光",
    "n90017":"强盗",
    "n90018":"强盗",
    "n90019":"强盗",
    "n90020":"强盗",
    "n90202":"黑衣人",
    "n90203":"黑衣人",
    "n90204":"黑衣人",
    "n90205":"黑衣人",
    "n90208":"黑衣人",
    "n90209":"黑衣人",
    "n90210":"黑衣人",
    "n90211":"黑衣人",
    "n90212":"黑衣人",
    "n90213":"黑衣人",
    "n90214":"黑衣人",
    "n90216":"黑衣人",
    "n90402":"段思良",
    "n90403":"董迦罗",
    "n51009b":"何白芍",
    "n90406":"董府护卫",
    "n90407":"董府护卫",
    "n90409":"黑衣人",
    "n90410":"黑衣人",
    "n90411":"黑衣人",
    "n90412":"黑衣人",
    "n90413":"黑衣人",
    "n90415":"南诏士兵",
    "n90416":"南诏军队长",
    "n90417":"南诏士兵",
    "n90418":"南诏士兵",
    "n90419":"南诏士兵",
    "n90420":"南诏士兵",
    "n90421":"南诏士兵",
    "n90422":"南诏士兵",
    "n90423":"南诏士兵",
    "n90425":"杨天义",
    "n90427":"金鼎禅师",
    "n90432":"不赦楼门人",
    "n90433":"不赦楼门人",
    "n90434":"南诏士兵",
    "n90435":"南诏士兵",
    "n90443":"不赦楼门人",
    "n90444":"不赦楼门人",
    "n90445":"不赦楼门人",
    "n90446":"不赦楼门人",
    "n90503":"阿月阿兰",
    "n90504":"阿季阿宇",
    "n90507":"江升",
    "n90508":"阿杰阿戈",
    "n90509":"阿玉阿姗",
    "n90510":"阿戈阿向",
    "n90511":"阿姗阿艾",
    "n90512":"阿加阿腾",
    "n90513":"阿加阿部",
    "n90514":"阿月阿英",
    "n90515":"阿奇阿满",
    "n90517":"猎鹰",
    "n90518":"猎鹰",
    "n90519":"猎鹰",
    "n90520":"猎鹰",
    "n90521":"猎鹰",
    "n90522":"猎鹰",
    "n90523":"猎鹰",
    "n90524":"猎鹰",
    "n90525":"灰狼",
    "n90526":"黑狼",
    "n90527":"灰狼",
    "n90528":"灰狼",
    "n90529":"黑狼",
    "n90530":"白狼",
    "n90531":"行商",
    "n90532":"杂工",
    "n90602":"白露霜",
    "n90602c":"白露霜",
    "n90603":"李彦仙",
    "n90604":"马从义",
    "n90605":"孙富春",
    "n90606":"马府 婢女",
    "n90607":"马府 守卫",
    "n90608":"纯阳子",
    "n90628":"明教教众",
    "n90629":"明教教众",
    "n90613":"青城派门人",
    "n90614":"青城派门人",
    "n90615":"青城派门人",
    "n90616":"青城派门人",
    "n90617":"崔二",
    "n90618":"蜀川分舵 副舵主",
    "n90619":"丐帮帮众",
    "n90620":"丐帮帮众",
    "n90621":"丐帮帮众",
    "n90623":"不赦楼门人",
    "n90624":"不赦楼门人",
    "n90625":"不赦楼门人",
    "n90627":"明教教众",
    "n90632":"仓库守卫",
    "n90633":"豹王寨众",
    "n90634":"豹王寨众",
    "n90635":"豹王寨众",
    "n90636":"豹王寨众",
    "n90637":"不赦楼主",
    "n90637b":"不赦楼主",
    "n90638":"不赦楼门人",
    "n90639":"不赦楼门人",
    "n90640":"花豹",
    "n90641":"花豹",
    "n90642":"花豹",
    "n90643":"擎天寨 大门守卫",
    "n90644":"擎天寨 大门守卫",
    "n90645":"擎天寨众",
    "n90646":"擎天寨众",
    "n90647":"擎天寨枪兵",
    "n90648":"擎天寨枪兵",
    "n90649":"擎天寨弓箭手",
    "n90657":"擎天寨弓箭手",
    "n90650":"擎天寨弓箭手",
    "n90658":"擎天寨弓箭手",
    "n90651":"豹王寨众",
    "n90652":"豹王寨众",
    "n90653":"豹王寨众",
    "n90654":"豹王寨众",
    "n90655":"花豹",
    "n90656":"花豹",
    "n90659":"擎天寨弓箭手",
    "n90660":"擎天寨弓箭手",
    "n90661":"擎天寨弓箭手",
    "n90662":"擎天寨弓箭手",
    "n90663":"擎天寨弓箭手",
    "n90664":"擎天寨弓箭手",
    "n90665":"擎天寨弓箭手",
    "n90666":"擎天寨弓箭手",
    "n90667":"擎天寨弓箭手",
    "n90668":"擎天寨弓箭手",
    "n90669":"擎天寨弓箭手",
    "n90670":"擎天寨弓箭手",
    "n90671":"擎天寨守卫",
    "n90672":"擎天寨守卫",
    "n90673":"擎天寨守卫",
    "n90674":"擎天寨守卫",
    "n90675":"擎天寨守卫",
    "n90677":"擎天寨守卫",
    "n90678":"擎天寨守卫",
    "n90679":"擎天寨守卫",
    "n90680":"擎天寨守卫",
    "n90681":"擎天寨守卫",
    "n90682":"不赦楼门人",
    "n90683":"不赦楼门人",
    "n90684":"不赦楼门人",
    "n90685":"不赦楼门人",
    "n90686":"花豹",
    "n90687":"花豹",
    "n90688":"花豹",
    "n90689":"花豹",
    "n90690":"花豹",
    "n90691":"花豹",
    "n90692":"花豹",
    "n90693":"花豹",
    "n90694":"花豹",
    "n90695":"花豹",
    "n90701":"王招财",
    "n90702":"王大娘",
    "n90703":"王阿宝",
    "n90704":"王阿进",
    "n90705":"黄老太",
    "n90706":"黄老丈",
    "n90707":"黄大顺",
    "n90708":"黄大娘",
    "n90709":"黄小福",
    "n90710":"村妇"}